module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This onion defies description, suffice it to say that the flowers look like the hair on Don King’s head (or for my more mature readers, Phyllis Diller’s hairdo). I try in vain to teach this species to my students, and while the slides help, seeing the real thing up close and personal makes instant alliophiles. The 1/2\" wide, pink starry flowers are first produced on short flower stalks (pedicels) like a normal onion but then proceed to form additional infertile flowers on pedicels longer than the first ones. The effect reminds one of the physics experiment with the static machine that makes your hair stand on end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As gruesome of the above description sounds, it really is a neat garden plant. The 4-8 blue-green leaves are produced early in the spring and deteriorate after flowering has finished. The stems are compact and stout and require no help to support their floral and seed display. The floral fireworks leaves behind the same exploding seed head, ornamental long after the pink of the flowers has faded into memory. The seed heads may be dried for winter decoration, however, if left to their own devices, they eventually fall off and become garden tumbleweeds, rolling around with each gust of wind, resulting in the apt common name. The main reasons so few of these bulbs are found in North American gardens are the cost and relative lack of cold hardiness. But they are worth it, for how else can you bring Don and Phyllis in your garden and not have to listen to them? Plants should be well mulched in zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sphaerocephalon")])]), _vm._v(" (sfay-roe-sef' a-lon)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Drumstick Chives")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-3 6/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the finest alliums for both cut flowers and the garden. The 3-5 hollow, semi-cylindrical leaves resemble inflated chive leaves. The oval to round 2\" wide flower heads consist of 50-100 flowers. Each flower bud is green and with maturity, the flowers turn purple, giving the inflorescence a two-tone effect. Flowers open in mid June and persist for two-three weeks. The stamens are longer than the tepals and provide an airy feel to the flower heads. It is excellent in hot climates and performs very well as far south as zone 8. The flowers are persistent on the plant and as a cut flower, last up to 10 days in water. The only reason I can see that this species has been overlooked and underused in North American gardens is that it is rather skinny and at least a dozen bulbs are needed to make a show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant multiple bulbs 6\" apart and 6\" deep in a sunny exposure. One or two plants are not effective and a grouping is essential. By the way, here is another plant whose name neither the taxonomic nor bulb grower communities can agree on. For years, it has been sharing the names "), _c('em', [_vm._v("sphaerocephalum")]), _vm._v(" and "), _c('em', [_vm._v("sphaerocephalon")]), _vm._v(". The more recent literature suggests the latter is correct, so end of story. Bulblets may be separated after 2-3 years and seed may be treated similar to "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-thunbergii")])]), _vm._v(" (thun-berg-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japanese Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-24\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I first saw this onion with my friend Galen Gates of the Chicago Botanic Garden. On that cool fall day, other plants were bedding down but the shiny grasslike green leaves and purple flowers were outstanding. He shared a few bulbs with me and they were equally good in my garden in Athens. The tufts of leaves persist throughout the season and in September to November, the starry violet flowers are fresh and inviting. The stamens and style are elongated and appear to dramatically increase the size of the umbel. Full sun is necessary for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ozawa’, introduced by George Schenk, is the best known and most popular, growing about 9-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-triquetrum")])]), _vm._v(" (tri-kwee' trum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Three-Cornered Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is easily recognizable by feeling the three-sided scape which supports a 2 1/2\" diameter inflorescence of six to eight 1/2\" long pendulous, white flowers, borne primarily on one side of the flower stem. Each bell-shaped flower has a central stripe of green and the stigma is deeply 3-parted, another characteristic useful in separating the three-cornered onion from others. The flowers are fragrant, but not nearly as sweet as those of "), _c('em', [_vm._v("A. neapolitanum")]), _vm._v(". The foliage consists of three to four 1\" wide, keeled leaves. It is common in hedgerows in England and New Zealand. In the Gardens at UGA, this is one of our finest bulbs, spreading over the years through the creeping phlox, making even that colorful plant look better. They are spreading, but not invasive. Yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant bulbs in well-drained soils in full sun. Seeds germinate readily and can create a weed problem the following spring if growing conditions are conducive. The seeds are dispersed by ants and ants can travel a long way. Some gardeners remove the flowers as soon as flowers have wilted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by the many bulblets formed after the first year or by seeds treated similarly to those of "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("pendulinum")]), _vm._v(" has larger flowers borne on all sides of the umbel. It is more useful as a cut flower than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. carinatum")]), _vm._v(", keeled garlic, has about 30 cup-shaped purple flowers in the pendulous umbels. The inflorescences usually include bulbils. var. "), _c('em', [_vm._v("pulchellum")]), _vm._v(" has rosy lilac flowers and lack bulbils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. cernuum")]), _vm._v(", wild nodding onion, is native to the northeastern United States and bears nodding lilac-pink flowers. The scape never straightens out entirely, thus nodding onion is a particularly appropriate name. Plants are usually about 18\" tall but can be quite variable. Leaves persist into the late summer, and have little onion odor. Bulbs are carried on a short rhizome and are easy to grow. They provide a wonderful early summer show when placed in groups of three to six, and will tolerate light shade or full sun. Self-sowing can be a problem, if so, deadhead immediately after flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0070-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium cernuum")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_c('em', [_vm._v("A. cyaneum")]), _vm._v(" has dark blue to purple star-shaped nodding flowers on 6-9\" tall scapes borne from small ovoid bulbs, clustered on a small rhizome. Plants are native to western China, and a terrific summer bloomer. The grassy foliage disappears soon after flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. insubricum")]), _vm._v(" bears pink bell-shaped flowers and is often confused with "), _c('em', [_vm._v("A. narcissiflorum")]), _vm._v(". Plants differ by having green leaves and flowers that are pendulous both in bud and in flower. "), _c('em', [_vm._v("A. insubricum")]), _vm._v(" tolerates wetter conditions than "), _c('em', [_vm._v("A. narcissiflorum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. mairei")]), _vm._v(" var. "), _c('em', [_vm._v("amabile")]), _vm._v(" flowers in late summer and fall like "), _c('em', [_vm._v("A. thunbergii")]), _vm._v(" and produces slender bulbs clustered on a rhizome and persistent grassy leaves. The funnel-shaped nodding flowers are magenta to deep pink and plants are 5-6\" tall. Plants used to be listed as "), _c('em', [_vm._v("A. amabile")]), _vm._v(". Good garden plants regardless, probably hardy in zones 6-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. obliquum")]), _vm._v(" is a bright lemon-yellow flowered species, bearing unique cup-shaped flowers. The yellow is a nice break from the more strident yellows of daisies and sundrops often found in the early summer garden.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('em', [_vm._v("A. ramosum")]), _vm._v(", fragrant flowered garlic, bears many bell-shaped white flowers with a dark red stripe in 2\" wide umbels. The foliage is narrow and persists until the flowers are produced in late summer or fall.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rosenbachianum")]), _vm._v(" easily grows 4' tall and produces 4\" wide spherical umbels consisting of hundreds of star-shaped deep lavender flowers in the spring. ‘Album’ is a creamy white form growing about 3 1/2' tall. The foliage disappears quickly, leaving the long naked flower stem with its cargo of flowers and later seed heads. I grow mine through a large clump of "), _c('em', [_vm._v("Baptisia pendula")]), _vm._v(", so that after the flowers of the "), _c('em', [_vm._v("Baptisia")]), _vm._v(" are finished, the globes of the onion continue. They differ from "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" in that their tepals become twisted and reflexed but whose umbel remains well formed as it dries and produces large quantities of seed. "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" has tepals that remain unreflexed, the umbel falls apart by late summer and seldom produces much seed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sikkimense")]), _vm._v(" has bell-shaped, pendant, deep blue to purple flowers held on short scapes, each about 8-10\" long. Plants are excellent in rock gardens, blooming in early to midsummer. Likely hardy in zones 6-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. stipitatum")]), _vm._v(" is another "), _c('em', [_vm._v("A. giganteum")]), _vm._v("/"), _c('em', [_vm._v("A. rosenbachianum")]), _vm._v(" lookalike. Plants bear 3-4' tall scapes topped with globular fragrant lilac flowers. It differs in that the tepals (petals) reflex downward and wither after flowering, while those of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" are persistent. The leaves are narrower, about 1-1 1/2\" wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. tuberosum")]), _vm._v(", garlic chives, has creamy white flowers and narrow chivelike leaves. It is similar to "), _c('em', [_vm._v("A. ramosum")]), _vm._v(" but differs by having star-shaped flowers with a faint green or brown stripe. Introduced from southeast Asia, it can become an aggressive weed in many parts of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ursinum")]), _vm._v(", ramsoms, is about 10\" tall and bears 15-20 white flowers in flat 2\" diameter umbels in late spring. The strongly onion-scented plants consist of two to three elliptical leaves with long petioles. Plants are more tolerant of shade than most alliums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. virgunuculae")]), _vm._v(" produces stems with 2-12 pink, star-shaped flowers in October and November. The grassy leaves look good all season. A small grouping makes a lovely setting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hybrids of "), _c('em', [_vm._v("A. macleanii")]), _vm._v(" and "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(" were developed by F. Bijl van Duyven-bode of J. Bijl Nurseries in Holland. Leaves decline quickly and flowers are sterile, therefore they persist on the plant for a long time. More expensive but well worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gladiator’ is 3-4' tall with large lilac-purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lucy Ball’ is a sport of ‘Gladiator’ with dark violet flowers. Stands about 4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rien Poortvliet’ bears great lilac flowers on 3-4' tall stems.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("‘Globemaster’, a hybrid between "), _c('em', [_vm._v("A. christophii")]), _vm._v(" and "), _c('em', [_vm._v("A. macleanii")]), _vm._v(", is without doubt, one of the best ornamental onion I have ever tried. The robust plants stand about 2 1/2' tall on strong self-supporting stems. The stems must be strong because the lavender flowers are held in 4-6\" wide globular heads. The flowers continue to open over many weeks, the newer ones “replacing” the older ones. While other members of the genus have come and gone, ‘Globemaster’ still shines. The seed heads remain ornamental well into the summer. It was originally bred as a cut ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("flower in Holland by van Duyvenbode and as more gardeners discovered it, the price decreased significantly.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Millennium’ was bred by Mark McDonough and appears to have a good percentage of "), _c('em', [_vm._v("A. nutans")]), _vm._v(" in the parentage. Plants are about 1' tall and equally wide with rose-purple flowers in late summer. Zones 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sugar Melt’ is only about 6\" tall when not in flower, but growing almost to a foot and a half when the flowers open in midsummer. The balls of flowers are light pink. Particularly attractive for rock gardens. Bred by Mark McDonough from "), _c('em', [_vm._v("Allium nutans")]), _vm._v(" and "), _c('em', [_vm._v("Allium senescens")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alstroemeria")])]), _vm._v(" (ahl-stro-meer-e' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Peruvian Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alstroemeriaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Approximately 50 species, all native to South America, are known. They generally grow from tubers, produce alternate leaves and have wonderfully interesting flowers. Peruvian lilies have become extremely popular as cut flowers, produced in fields and greenhouses in California, Holland, Colombia, Israel and other cut flower-producing regions. Generally cut flower production involves hybrids of "), _c('em', [_vm._v("A. ligtu")]), _vm._v(" and "), _c('em', [_vm._v("A. aurea")]), _vm._v(" but most of these are poor garden plants in all but a few areas of the country. In areas on the West Coast, the orange-yellow flowers of "), _c('em', [_vm._v("A. aurea")]), _vm._v(" brighten gardens and once established can roam about at will. "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(" is another wonderful golden-orange species but seldom survives extremes of heat and cold common to most areas of the United States. ‘Lutea’ is particularly handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-psittacina")])]), _vm._v(" (sit-a-seen' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Parrot Lily")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red/Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("South America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a rather common plant in the Southeast, and once established, can become a bit of a nuisance. Having said that, they are a joy when the flowers, which are an odd mix of green and wine red, spotted or streaked with maroon, start to open in early to midsummer. The color combination sounds rather weird, but they are weirdly delightful. Flowers begin in early June and continue for 4-5 weeks. Like all members of the genus, they are excellent cut flowers, albeit a rather difficult color to place with anything else. That’s why bud vases are sold. Two to three flowers are produced in each terminal inflorescence. "), _c('em', [_vm._v("A. psittacina")]), _vm._v(" performs best in partial shade, but too much shade results in leafy, poor-flowering plants. Easy to divide, these are the ultimate pass-along plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has far more handsome foliage than the species and should be used more often. Perhaps not quite as aggressive but you will be giving some away soon enough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids:")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Large-flowered colorful alstroemerias, such as seen in the florist shop, have not been particularly resilient in the much of the country. However, a couple of fine fellows, Mark Bridgen, presently at Cornell University, and George Hare of California, have provided a number of hybrids that combine cold tolerance with excellent flowers. ")]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("This are wonderful breakthrough plants for gardeners, although I still would not recommend them for my daughters in the Southeast. However, many more people have considerably more choice than ever before.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Freedom’ bears rose-pink flowers in early summer atop 2' tall stems. All Dr. Bridgen’s breeding was done in Connecticut, and plants are cold hardy to at least zone 5b.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glory of the Andes’ is a variegated leaf form of ‘Sweet Laura’. The leaves have a nice creamy yellow margin.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sweet Laura’ provides golden flowers with red petal tips, speckled with brown, on 1-2' tall plants. Flowers open in mid to late summer. A Bridgen hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Third Harmonic’ sports plants about 3' tall. The backs of the golden flowers are maroon. Each flower is flecked with black. Bred by George Hare, cold hardy to zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other beautiful hybrids are also available, but are more suited for containers, lacking the weather tolerance of the above cultivars. They include the coral peach and yellow flowers of ‘Princess Victoria’, the yellow and burgundy flowers of ‘Yellow Friendship’ and the light and dark pink blossoms of ‘Dusty Rose’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alyssum")])]), _vm._v(" (a-lis' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Madwort")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The large genus consists of over 150 species, mostly native to alpine and northerly areas, and most do poorly in hot, wet summers. Plants are usually small in stature and are outstanding for rocky crevices or rock garden areas. The majority bear yellow flowers. Taxonomists removed the most popular old alyssum ("), _c('em', [_vm._v("A. saxatile")]), _vm._v(") to the genus "), _c('em', [_vm._v("Aurinia")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of fine species are occasionally offered and seed may also be found through specialty organizations, such as the North American Rock Garden Society. "), _c('em', [_vm._v("A. montanum")]), _vm._v(", mountain madwort, is an 8-10\" tall ground cover, with finely cut foliage and masses of bright yellow spring flowers. ‘Mountain Gold’ is a more compact, floriferous cultivar and ‘Luna’, a Fleuroselect winner in 2003, may be even better, at only 5-6\" tall. Hardy in zones 2 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. wulfenianum")]), _vm._v(" is prostrate, about 8\" tall, with gray leaves and light yellow flowers in early spring, while "), _c('em', [_vm._v("A. argenteum")]), _vm._v(" produces handsome foliage with gray on the top and green beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All require excellent drainage and do best in full sun. None does particularly well in the South, although if planted in the fall, they are wonderfully bright in the spring, but decline as the heat of summer arrives.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('strong', [_vm._v("X")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Amarcrinum")])]), _vm._v(" (a-mare-cry' num)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Amarcrinum")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Amaryllidaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The intergeneric cross between "), _c('em', [_vm._v("Amaryllis belladonna")]), _vm._v(" and "), _c('em', [_vm._v("Crinum moorei")]), _vm._v(" is way underused, particularly in southern gardens. The hybrid, known as "), _c('em', [_vm._v("A. memoriacorsii")]), _vm._v(", bears 1 1/2' long straplike dark green leaves in the summer and fragrant pink flowers on 15\" long scapes in late summer to fall. Plant bulbs to a depth of about three times their diameter in late fall or early spring for best performance.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("I think these are wonderful bulbs, and can’t imagine my garden without them. Their biggest limitation for the rest of the country is the fact that they are cold hardy only to zone 7. However, there is enough beauty here to treat them as annual bulbs in containers or bring them in as you would with dahlias.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dorothy Hannibal’ has lighter pink flowers than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fred Howard’ has light pink flowers with a darker pink streaking throughout the flowers. A handsome plant named in 1920 for Mr. Howard, a breeder in Los Angeles. This is occasionally (and incorrectly) labeled as "), _c('em', [_vm._v("A. howardii")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Amianthium")])]), _vm._v(" (am-ee-an-the' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Fly-poison")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Liliaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Who said fly traps have to come in a spray can or sticky strips? All parts of the plant are poisonous, although the folklore about poisoning flies is a bit of a mystery. Perhaps because an excellent fly poison results when the small bulbs are mixed with honey or syrup, although fly paper is a lot cheaper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only one species occurs in this genus, "), _c('em', [_vm._v("A. muscaetoxicum")]), _vm._v(", and it is native from Pennsylvania and New York south to Florida and west to Arkansas. Grazing cattle have been known to be poisoned, thus names like fall-poison and stagger grass have also been attached to these plants. Such morbidity makes for good stories but plants are also quite ornamental. They produce long racemes of clean white flowers, and when allowed to grow in large groups, brighten the woodland landscape. The basal leaves are usually more than a foot long but only about an inch wide. They flower in May in the South and in June further north. A wonderful population may be seen at the Atlanta History Center in the terrific native garden tended with great care by Sue Vrooman.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Amorphophallus")])]), _vm._v(" (a-mor-fo-fal' us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Snake Palm")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("That plants of this genus belong in a garden is a given, that they belong in yours or mine may be debatable. Membership in the Araceae puts them in the same company as caladiums, calla lilies and jack-in-the-pulpits, characterized by the unmistakable spathe and spadix arrangement of flowers. Approximately 100 species of these bulbous plants are known, all are denizens of leafy moldy places in moist, shaded habitats. Some are used for their edible tubers, but if grown in the garden, their compound foliage, marbled stems and dramatic, often evil-smelling inflorescences should be enjoyed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("Flowers of this group of plants have memorable effluvia, often assailing the nostrils with a barrage of odor. Sir Joseph Hooker described the odor of the huge flower of "), _c('em', [_vm._v("A. titanum")]), _vm._v(" as a “mixture of rotting fish and burnt sugar, which turns your stomach over and makes your eyes run”. Perhaps that is why its common name is corpse flower! Knowing my fondness for such weird plants, Tony Avent of Plants Delight Nursery in Raleigh, North Carolina brought me a tuber of devil’s tongue many years ago. I have since planted dozens more, mostly for their fabulous stems and foliage. Not all plants want to flower every year, which is probably just as well as my neighbors, let alone my ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("wife Susan, would not be impressed. The scent of this species was described by a visitor at a flower show when “We detected the scent of pure rot. Following our noses, we came across two huge, liver-colored inflorescences atop five-foot stalks which arose from naked corms the size of pumpkins.” I have not been as vigorously assailed, but when they are flower in May, it is tough to walk by without noticing.")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They seem to be most at home in heavy shade and a reasonably moist area. When they do not flower, it is easy to forget they are there. However in June, long after most plants have risen and are growing well, "), _c('em', [_vm._v("Amorphophallus")]), _vm._v(" gives a big yawn, stretches, and breaks through the soil. Seeing that purple mottled stem rise like a phoenix and watching the foliage unfurl can keep me occupied for days. Generally a single leaf emerges and branches repeatedly, the two branches of each division basically equal. The name for this kind of leaf shape is “dichotomous”, in case one cares. Regardless of my ineptness at describing them, let’s just say the leaves and stem are by far the best parts of the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been an awakening in American gardening to plants in this genus, and one can now find a handful of species through specialty nurseries, or through the Internet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other similar genera occasionally presented to the gardener such as "), _c('em', [_vm._v("Dracontium")]), _vm._v(" and "), _c('em', [_vm._v("Sauromatum")]), _vm._v(" offer weirdness of habit, foul odor and curious, often disparaging comments. Who could ask for more?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are confused by all the voodoo lilies, here are a few of the more obvious differences.")]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Amorphophallus konjac")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Dracontium vulgaris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Sauromatum venosum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spathe color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dull violet with yellow")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spathe shape")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3-4' wide")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1' long, 6\" wide, arching")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2' long, pointed, flattened back")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spadix")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Deep purple")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf number")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Usually One")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Several")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf shape")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dichotomous")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sickle-shaped")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sickle-shaped")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-konjac")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Devil’s tongue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer/fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("India, Sumatra")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the beast that Tony shared with me, putting me on the slippery slope of aroids. At one time, it was called "), _c('em', [_vm._v("A. riveri")]), _vm._v(" subsp. "), _c('em', [_vm._v("konjac")]), _vm._v(", but it has recently been reclassified. It is the most common simply because it is the most cold hardy and most easily available. While its garden attributes may be debated, its importance as a food crop is well known in Indonesia, Southeast Asia, India and the Pacific Rim. In many regions, the corms are important standbys when the rice crop fails. In Japan, a traditional food made from the corm is known as konnyaku, and industrial uses for the carbohydrates (mannose, starches) in the dark-skinned corm have also been discovered. Gelling properties for convenience foods and dietary supplements for weight loss are being investigated.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("Plant tubers in partial shade, approximately 3 times deep as the tubers are wide. This may be a large hole. Do not be concerned if they do not flower, it may take 3-5 years before the tubers are significantly mature. Plants do not normally emerge until late spring or even early summer. Hang in there, the stems and leaves are well worth the wait.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Leo Song’ is similar to the species but has quite lovely creamy white stems, still mottled in purple.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Additional Species")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gardeners have always lusted for additional species, and today there are more than ever before. The aforementioned Mr. Avent lists nine different taxa in his 2007 catalog, unheard of 5 years ago. The International Aroid Society is a wonderful source of photos and growing information. However, be prepared to pay top dollar, and once paid, say thank you to the people who are making them available. If you are fortunate to find a good species, you have ornamental value, dietary value and nasal exercise all in one. Have fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bulbifer")]), _vm._v(", the voodoo lily, has 30-36\" tall mottled stems and palmately lobed foliage. The leaves form small tubers in late summer that may be removed for new plants. The spadix is green with a tinge of pink and appears in the spring before the foliage. Hardy in zones 8, perhaps to 7 to 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. dunnii")]), _vm._v(" bears a white bulbous spadix half surrounded by a green and white mottled spathe. Plants are about 2' tall and still produce the wonderful speckled stalk and voodoo leaves. Plants have not been tested sufficiently but are likely hardy in zones 8 (7)-10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. muelleri")]), _vm._v(" was introduced to gardeners by Tony Avent of Plant Delights Nursery in 2005. Plants have a large white spadix enclosed with a pink-purple spadix. The flower stem is mottled purple but the petioles are often mottled white. Like "), _c('em', [_vm._v("A. bulbifer")]), _vm._v(", this also produces small tubers on the stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. thaiensis")]), _vm._v(" holds flowers on a foot-long stalk, the inflorescence consists of a green spathe suffused with pink and a spadix that is white at the base, progressing to pink at the top. The plants are characterized by a single petiole marked with brown to purple spots.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('em', [_vm._v("A. titanum")]), _vm._v(", titan lily, giant voodoo lily, is certainly the most famous, and in its native Indonesian environment has flowers up to 15' tall. The mottled stems and foliage are equally impressive. Many botanical gardens now grow the tuber and often announce when the titan lily will be flowering. Do people actually stand in line to see something that smells, even if it’s huge? In 1999, when the titan lily flowered at Huntington Botanical Gardens in California, more than a few people showed up. According to the garden staff, “During the 19 days it was on public view, before and after blooming, the "), _c('em', [_vm._v("Amorphophallus titanum")]), _vm._v(" drew an unprecedented total of over 76,000 enthusiastic flower fans. Television coverage alone lasted for 18 consecutive days. Numerous front-page newspaper stories appeared, and countless radio interviews and news stories were broadcast, ranging from National Public Radio and the ")]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("BBC to alternative rock station KROQ.” This does not even mention the refrigerator magnets, coffee cups and t-shirts that were sold by the hundreds. So, yes, people really do line up for the weird and wonderful. You have reached la-la land when you find yourself in such a line. Plants are seldom for sale, and if they are, they cost as much as a Beamer. Like the Beamer, they need to be brought in for the winter.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. yuloensis")]), _vm._v(" is probably hardy to at least zone 7b; produces wonderfully deeply cut foliage and cream-colored spathe and spadix.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ampleaster")])]), _vm._v(" (am-plee-as' ter)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("See "), _c('em', [_vm._v("Aster")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_c('em', [_c('strong', [_vm._v("Amsonia")])]), _vm._v(" (am-sown' ee-ah)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue Star Flower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Apocynaceae")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This North American genus contains some fine low-maintenance, resilient species for the garden. Light blue to almost white star-shaped flowers are held in terminal panicles above the alternate leaves. There are approximately twenty species in the genus although only 3 or 4 are available to the gardener. Amsonias provide early blue flowers, disease and insect resistance, and fall color. The fruits (follicles) are long and narrow; in some species they are erect while others bear spreading or pendant fruit. Certainly one of my favorite plants is the common blue star flower, "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(", however, the Arkansas amsonia, "), _c('em', [_vm._v("A. hubrichtii")]), _vm._v(" and the downy amsonia, "), _c('em', [_vm._v("A. ciliata")]), _vm._v(", are also excellent garden plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Amsonia Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Young leaves obviously hairy")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Approx width of leaves")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ciliata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Y")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1.5\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light blue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hubrichtii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light blue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tabernaemontana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ciliata")])]), _vm._v(" (sill-e' a-ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Downy Amsonia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An excellent plant for many gardens, plants provide handsome 1/2\" wide unblemished foliage and good flowering in the same package. The linear to lanceolate dark-green leaves have a fringe of silky hairs that are particularly handsome in the early season, but with maturity, they lose much of their silkiness. However, if the plant is cut back after flowering, the new growth returns as feathery as before. The leaves are crowded toward the upper end of the stems and the margins slightly curled back toward the underside of the leaves (revolute). The foliage is seldom touched by insects or disease. The light blue starry flowers open in spring and persist for 3-4 weeks. Some species of amsonia provide marvelous fall color in the garden. The foliage of downy amsonia is one of them, providing a golden yellow hue until frost.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("Plant in full sun or light, dappled shade and provide sufficient moisture to survive dry periods. Although no serious pests occur, stems may need cutting back at least ")]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("once during the season to keep them from falling over, particularly if planted in a shady area. If plants remain evergreen, cut back hard in very early spring.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed, division, and terminal cuttings taken during the spring are all viable means of propagation. Store the seed at about 40°F for 4-6 weeks because untreated seed germinates irregularly. Chipping or cutting away a small piece of one end of the seed and soaking overnight in water results in better germination. Division is not necessary for 8-10 years but is a quick way to increase a planting. Cut through the crown in late spring or fall so that each division consists of at least one growing point. Terminal cuttings from lateral branches collected in May and treated with a rooting hormone (one labeled for herbaceous plants) root faster and more uniformly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("filifolia")]), _vm._v(" is really a neat-looking amsonia. I first saw this plant in the garden of plantsman Allen Bush in Louisville, Kentucky and was most impressed. Plants are prostrate, much like a ground cover, and have wonderfully feathery leaves. The light blue flowers occur in the spring. It is being sold as the variety and as ‘Georgia Pancake’, a particularly unattractive name for such an attractive plant.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hubrichtii")])]), _vm._v(" (ew-brickt-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Threadleaf, Arkansas Amsonia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pale Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("South-central United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many writers (this one included) have written the name incorrectly as "), _c('em', [_vm._v("hubrectii")]), _vm._v(", which is as wrong as E before I except after C. If there was one reason to update this book, it was to apologize, belatedly, to Leslie Hubricht, an extraordinary man who found the plant in 1942. Leslie (and others), apologies from me and my less than bright colleagues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I wrote my original book in 1989, hardly anyone knew this plant; today it is probably as popular as any species in the genus. The foliage is feathery, like "), _c('em', [_vm._v("A. ciliata")]), _vm._v(", but leaves are threadlike and longer (3\"). The flowers are lighter blue than blue star flower and, in fact, are almost white as temperatures warm up in spring. The early flowers are easily visible but the foliage tends to cover the flowers that open later. The narrow foliage makes a marvelous display throughout the season, and some people claim that the golden-yellow spectacle in the fall is quite spectacular. While it is true that they turn golden in the fall, let’s not get too carried away with this spectacular thing. Without doubt, they provide excellent color compared to other herbaceous plants, but they certainly don’t compete with a maple. Plants are more colorful in the North than the South.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Armitage garden, it tends to get a little too tall and floppy, and while I prefer common blue star, I enjoy the look of the foliage of this plant as well. Fall color in warm climates is highly overrated, and although a little better than blue star flower, plants are not as exciting in my garden as in the Midwest or North. Plants grow about 3' tall and equally wide. Full sun is best; plants do not tolerate shade well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cut back in early spring. Division or cuttings are effective methods to increase numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrid:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Seaford Skies’ was discovered by Pamela Harper, from Seaford, Virginia, one of the great grand-dames of American gardening. Plants appear to be hybrids between "), _c('em', [_vm._v("A. hubrichtii x A. tabernaemontana")]), _vm._v(", providing the fernlike foliage and good fall color of the former with the vigor of the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tabernaemontana")])]), _vm._v(" (tay-ber-nay-mon-tan' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Blue Star Flower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaves are wider, flowers are darker and plants are among the best for full sun to partial shade in most gardens in America. Plants are native from Pennsylvania to South Carolina and west to Kansas, and are found along roadsides or in sunny fields. This species is more cold hardy than the previous and much more common. The flowers are a good dark blue, but they may fade a little over time. The foliage also turns golden yellow in the fall, but does not compete with threadleaf amsonia. For me, blue star flower is always on my list of “no-brainers”. Plant and get out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants have alternate willowlike leaves and many 1/2-3/4\" pale blue star flowers clustered in loose terminal inflorescences in spring to early summer. They are particularly lovely in the early spring as they break through the ground and rapidly extend to their mature stature. If grown in full sun, pruning is not necessary, however, if grown in shade, plants must be supported or cut back after flowering to maintain shape. Plants perform best in full sun, but they tolerate some shade as well. In my shaded garden, I grow plants through a circular support frame to keep plants from falling over. Deep, moist soils and partial shade are ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0079-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Amsoina tabernaemontana")])])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Ice’ is the best-known cultivar, and is grown because of its compact habit (12-18\" tall). However, it does not appear to be as vigorous or as persistent as the species. It may be a hybrid, which may help to explain its relative wimpiness.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("montana")]), _vm._v(" (zones 5-9) is a dwarfer version of the species. Some taxonomists have split it into "), _c('em', [_vm._v("A. montana")]), _vm._v(". An exceptionally good plant, small enough to even find a place in the rock garden. ‘Short Stack’ was selected by Plant Delights Nursery as a more consistent, vigorous form. Plants are 10-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("salicifolia")]), _vm._v(" (sometimes listed as "), _c('em', [_vm._v("A. salicifolia")]), _vm._v(") has leaves 5-10 times longer than they are wide and is less erect than the species. The flowers have a white throat and a small beard within. Native to the southeastern United States. Propagation is similar to "), _c('em', [_vm._v("A. ciliata")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. illustris")]), _vm._v(" is native to the central United States and resembles "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(", bearing similar foliage and flowers. Plants differ by having thicker leathery leaves and pendant fruit. Cold hardiness to about zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ludoviciana")]), _vm._v(", Louisiana blue star, is native to southern Louisiana only and is distinguished by the white wool on the undersides of the leaves. Handsome even without flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. orientalis")]), _vm._v(" superficially resembles "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(" but is native to southern Europe. On close inspection, one can see short hairs along the margin and midribs of the leaves, whereas the leaves of "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(" are smooth (glabrous). Plants do not appear to be as cold hardy as common blue star flower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rigida")]), _vm._v(" is occasionally offered, bearing 2' tall stems and light blue flowers. Native to the Southeast, likely cold hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genera:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Rhazya orientalis")]), _vm._v(" is so similar to "), _c('em', [_vm._v("A. orientalis")]), _vm._v(" that it is considered a synonym. The late spring and summer flowers range from bright blue to violet. Plants are native to Greece and Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anacyclus")])]), _vm._v(" (an-a-psyc' lus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Mount Atlas Daisy")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Of the approximately 9 species of annual and perennial species, only the Mount Atlas daisy, "), _c('em', [_vm._v("A. pyrethrum")]), _vm._v(" var. "), _c('em', [_vm._v("depressus")]), _vm._v(" ("), _c('em', [_vm._v("A. depressus")]), _vm._v(") is easily available to North American gardeners. Plants produce fine basal foliage, forming ferny mats with a lovely gray-green cast. Plants grow 4-6\" tall and bear 1-1 1/2\" wide single white daisies with yellow centers and purple to red backs. Being native to the Mediterranean, excellent drainage is a necessity, at least in the East, and plants are more persistent ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("in sunny, dry rock gardens, gravel pathways or embedded in rock walls than in the border. Plants are more productive in areas of low rainfall and low humidity. Our plants at Georgia were wonderful the first year but succumbed to the winter wetness. Hardy from zone 5 to 7.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division or easy from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Garden Gnome’ is occasionally listed but I see no difference from the species. It is likely a common name that someone put some single quotation marks around.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silberkissen’ is even more compact than the species and bears gray foliage with silver hairs and pink-tinged white daisies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anaphalis")])]), _vm._v(" (an-naff' al-iss)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Pearly Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Anaphalis produces masses of small white flowers in August and September, usually with a brownish yellow center, but it is the foliage that is special throughout the growing season. The gray-white leaves create a cooling effect in the border and tone down the bright reds and oranges of flowers beside them. They are reasonably tolerant of moisture and are particularly useful in areas that are too wet for other gray-green plants such as "), _c('em', [_vm._v("Artemisia")]), _vm._v(" and "), _c('em', [_vm._v("Perovskia")]), _vm._v(". This is not to say they will jump with glee when placed in a swamp, but they are especially tough and can withstand significant abuse. Rich soil is not a prerequisite, but evenly moist soils are recommended because the foliage looks shabby under dry conditions. They are also at home in the naturalized or wildflower garden in full sun to partial shade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are alternate, entire, and sessile. The flower heads are small and crowded like small pearls at the ends of the branches. They can be cut and dried to make excellent “everlastings”.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed sown in late summer will produce flowering plants the next year but division is the most rapid means of propagation. Plants should be divided every 3-4 years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anaphalis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Underside of leaves woolly")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. margaritacea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. triplinervis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-margaritacea")])]), _vm._v(" (mar-ga-ri-tay' see-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Pearly Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-36\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America, Northeast Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("The 2-4\" long gray-green lanceolate leaves have a white, woolly pubescence on their undersides and the margins are rolled in. The rounded flower heads consist of dozens of 1/4 to 1/2\" diameter flowers that cover the plants like a carpet of snow in late summer. The common name refers to the long-lasting dried flowers. Under evenly moist conditions, plants grow up to 3' tall and equally wide. These are outstanding plants when a touch of gray is needed, and although they may take a couple of years ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("to look their best, once established, gardeners cherish it for its usefulness in the garden design. One of my favorite garden designers, Bobby Schwartz, of Shaker Heights, Ohio recommends it “be placed in the front of a deep border with tall asters, Joe Pye Weed or "), _c('em', [_vm._v("Helianthus")]), _vm._v(" ‘Lemon Queen’ behind it. Alternatively, it could be placed in the middle of a border with any of the above perennials behind it and "), _c('em', [_vm._v("Coreopsis verticillata")]), _vm._v(" ‘Moonbeam’ in front of it.” I love designers who understand that good garden design is based on knowing good plants from bad.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are native to the western United States but also extend across the entire northern half of the country and into Canada. They are not found in the Southeast of the Rocky Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("cinnamomea")]), _vm._v(" is probably the most common form available. The 1\" long leaves are 3-nerved and bear a lovely cinnamon hue on the undersides. Hardy in zones 4-7. It is interesting to note that much of the taller anaphalis offered by American nurserymen is var. "), _c('em', [_vm._v("cinnamomea")]), _vm._v(", native to India, while the majority of everlastings in English gardens is our native "), _c('em', [_vm._v("A. margaritacea")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("yedoensis")]), _vm._v(" produces about 2\" long, 1-nerved hairy leaves. Native to Japan and likely a little more cold hardy.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anaphalis triplinervis")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-triplinervis")])]), _vm._v(" (tri-plee-ner' vis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Three-veined Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Himalayas")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think I like this plant even more than the former because I can satisfy my “what is it?” curiosity. Trying to guess what these gray-leaved plants are is a challenge, but the obvious three veins (three nerves) on the undersides of the leaves makes my guess a little more accurate. The dense, white, woolly pubescent leaves, like other species, contrast and soften other green leaves and bright flowers in the garden. The stems have a more or less zigzag or wavy form (flexuous) which is especially evident if a few leaves are removed. The flowers, which open in July, are long lasting and continue until frost. This makes an excellent low-growing plant for the front of the garden and should be used more often.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Snow’ has clear white flowers over tufts of silvery gray foliage. The flowers are a “cleaner” white than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. nepalensis")]), _vm._v(" var. "), _c('em', [_vm._v("monocephala")]), _vm._v(" ("), _c('em', [_vm._v("A. nubigena)")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. triplinervis")]), _vm._v(" but is only 6-9\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anchusa")])]), _vm._v(" (an-koo' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Alkanet")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Boraginaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Of the 30 or so species, gardeners are lucky to see more than two or three. This is a good thing as most of the others are best left to nature; we have enough weeds without raising others. All are biennials or short-lived perennials (living for 2-3 years) and provide flowers in the blue range, a color often difficult to find in the spring and summer garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most members of the Boraginaceae are characterized by the presence of alternate leaves, hairy stems, and flower buds arranged in the shape of a scorpion’s tail (scorpioid cyme). Members of "), _c('em', [_vm._v("Anchusa")]), _vm._v(" also bear these characteristics. "), _c('em', [_vm._v("A. capensis")]), _vm._v(" may be one of the prettiest species for the front of the garden, but the 1-2' tall plant is best treated as a biennial or an annual. "), _c('em', [_vm._v("A. caespitosa")]), _vm._v(" grows about 3-5\" tall and bears extraordinary blue flowers, and is worth a try in the rock garden if plants or seeds can be obtained. The most popular and most tolerant species is "), _c('em', [_vm._v("A. azurea")]), _vm._v(", available in a number of stately cultivars. All species require excellent drainage for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-azurea")])]), _vm._v(" (a-zewr-ree' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italian Alkanet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("This tall-growing, coarsely hairy species can be a beautiful background specimen for full sun in the late spring garden. The 4-8\" long entire leaves are sessile or attached to the stem by the clasping base. The bright blue flowers are 1/2-3/4\" across and persist for about four weeks, depending on temperature. The important words in this discussion are “can be”, as they also can be a mess, with leaves turning black and plants askew. In the South, plants may reach 4' in height and require support. Do not ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("fertilize as they may become too lanky. I have seen some reseeding in rich soils but this is not a widespread problem.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is mainly by root cuttings. Take 1/2-3/4\" diameter cuttings, 2-3\" long, in early spring, place horizontally in moist, loose, well-drained soil at 65-75°F (also see "), _c('em', [_vm._v("Anemone")]), _vm._v("). Seed is commonly used; sow 1-2\" deep, place at 70-75°F and cover to maintain high humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dropmore’ was selected in 1905 and the deep blue flowers are still in demand. It reaches a height of 4' and is one of the more commonly offered cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Feltham Pride’ has deep blue flowers and grows about 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little John’ is a compact version of the species (1 1/2' tall) with dark blue flowers and a compact habit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loddon Royalist’ is still the most popular and most available cultivar today. Plants grow about 3' in height and have lovely gentian-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Morning Glory’ bears gentian-blue flowers on 4' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Opal’ was raised in 1906 and has azure blue flowers. This and ‘Dropmore’ are untidy in habit and occupy a great deal of garden space.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royal Blue’ is similar to ‘Loddon Royalist’ but has a deeper blue color.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Andropogon")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bluestem")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Poaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Grasses never go away, they only go to seed. The movement to ornamental grasses has continued unabated for years, and the inclusion of our prairie grasses into mainstream gardens simply accentuates the trend. There are number of bluestems, most are tall and rangy, but with the introduction of a few cultivars, gardeners and landscapers are more ready to try them out. Once established, they are all extremely drought tolerant and are favorites for reclamation purposes. Grow in full sun, mow or cut back hard in early spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name bluestem is often confused with little bluestem, "), _c('em', [_vm._v("Schizachyrium scoparium")]), _vm._v(" (which see).")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("- gerardii")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Big Bluestem, Turkey Foot Grass")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("5-7'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Tan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its height lends the plants more towards windbreaks, or along highways for erosion control, than in the garden. However, its reliable cold hardiness and drought tolerance have also made it a favorite for large landscapes and naturalizing areas such as meadows. Plants are essentially clump formers, although in warmer areas of the country like parts of Texas, they tend to be more rhizomatous. They are gaining popularity as landscape plants because of quick growth and the blue-green foliage that turns a handsome red in late fall. The summer flowers are formed on branched inflorescences, which some say resemble turkey feet, then are followed by drooping seed heads. Both the seed heads and the flowers make useful cut stems for drying.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Niagara’ has been selected for vigorous growth and tolerance to moist soils. Used mainly in conservation sites, but handsome in their own right. They grow up to 7' tall and sport red coloration in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pawnee’ was introduced to gardeners because it is only 4-5' tall, somewhat shorter than the species. Plants have a little darker green foliage and often take on a handsome red tinge in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. capillipes")]), _vm._v(", sometimes called chalky bluestem, bears narrow bluish foliage that turns a bronzy red in the fall. Plants grow 2-4' tall in clumps and do not spread aggressively. The silvery flowers occur in late summer and persist into the fall. Plants are native to warm areas in the southeastern U.S. and cold hardy only to zone 7. ‘Valdosta Blue’ was found by Bob McCartney near Valdosta, Georgia, and has deeper blue foliage than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. glomeratus")]), _vm._v(", bushy bluestem, broom grass, is tolerant of moist soils, rather unusual in this genus, and is a clump-forming grass. I think the broomlike inflorescences (hence the common name) and the habit make this a far more attractive and user-friendly species than big bluestem. The bronze to red foliage color and the soft flowers make it a winner even in the winter. Plants are not without problems; they are still big (4-6' tall), and can reseed, so some caution is needed. Clumps should be cut to the ground in early spring. Zones 3-8.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Androsace")])]), _vm._v(" (an-dros' a-kee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rock Jasmine")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Primulaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This relatively unknown group of plants consists of more or less xerophytic, low-growing alpines, all of which require excellent drainage. They are grown for their open, flat-faced flowers with a marked eye, borne over tight rosettes of leaves. In general, they prefer light sandy soils, low nutrient status, and good air movement. Most of the 100 or so species perform well in full sun, although "), _c('em', [_vm._v("A. geraniifolia")]), _vm._v(" is best in partial shade. While no species in this genus relishes the hot humid summers so common to the eastern United States, "), _c('em', [_vm._v("A. sarmentosa")]), _vm._v(", "), _c('em', [_vm._v("A. carnea")]), _vm._v(", "), _c('em', [_vm._v("A. lactea")]), _vm._v(" and "), _c('em', [_vm._v("A. lanuginosa")]), _vm._v(" are a little more forgiving. "), _c('em', [_vm._v("Androsace")]), _vm._v(" is most popular with gardeners on the West Coast and in Plains states where temperatures are cool and/or rainfall is limited.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few species and cultivars are offered by mail order nurseries as well as a few retail garden centers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. brigantiaca")]), _vm._v(" is larger, more robust and bears white flowers. "), _c('em', [_vm._v("A. carnea")]), _vm._v(" is a 4\" tall tufted ground cover with white or pink flowers. The species, along with the subspecies "), _c('em', [_vm._v("laggeri")]), _vm._v(" and "), _c('em', [_vm._v("rosea")]), _vm._v(" have all earned Medal of Honor awards from the RHS Garden Wisley in England. "), _c('em', [_vm._v("A. pyrenaica")]), _vm._v(" has gorgeous white flowers with a yellow eye.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Hybrids between "), _c('em', [_vm._v("A. carnea")]), _vm._v(" and "), _c('em', [_vm._v("A. pyrenaica")]), _vm._v(" have become more popular in recent years. ‘Callisto’ bears white flowers with a red eye, ‘Jupiter’ produces white flowers ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("with a dark red eye, ‘Millstream’ bears light pink flowers, ‘Rhapsody’ has clean pink flowers with a red eye, and ‘Venus’ bears many white flowers, each with a small yellow eye.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sarmentosa")]), _vm._v(" is offered by most nurseries that sell plants of this genus. Plants produce hairy, silver rosettes in early spring, later becoming less hairy. Plants spread by stolons to make a small patch and bear pink flowers with tiny yellow eyes. Most grow about 6\" tall. The variety "), _c('em', [_vm._v("chumbyi")]), _vm._v(" is more dwarf (about 3\") and bears deeper pink flowers. "), _c('em', [_vm._v("A. villosa")]), _vm._v(" is densely tufted with rosettes that look like little cushions, and usually bears lots of shaggy hairs on the leaves. Flowers are pink to white; var. "), _c('em', [_vm._v("jacquemontii")]), _vm._v(" bears pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemone")])]), _vm._v(" (a-nem' o-nee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Windflower")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Talk about a diverse genus! "), _c('em', [_vm._v("Anemone")]), _vm._v(" consists of approximately 100 species, from fibrous to tuberous rooted forms, from spring- to fall-flowering species. They are enjoyed around the world as greenhouse potted plants, florist cut flowers and garden plants. In 1629, John Parkinson wrote in "), _c('em', [_vm._v("Paradisi")]), _vm._v(" that “the sight of them doth enforce an earnest longing desire in the minde of anyone to be a possessour of some of them at the least, for ... is of it selfe alone almost sufficient to furnish a garden with their flowers for almost halfe the yeare ...”. Most species have compound leaves and apetalous (no petals) flowers, most of the color the result of the showy sepals. Three main groups of "), _c('em', [_vm._v("Anemone")]), _vm._v(" occur, based on their rootstalks and growth habit.")]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Rootstalk")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Flowering time")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Examples")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fibrous")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late summer, fall")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hupehensis, A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(",")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tomentosa")]), _vm._v(", "), _c('em', [_vm._v("A. vitifolia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber, rhizomes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("spring")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. blanda")]), _vm._v(", "), _c('em', [_vm._v("A. canadensis")]), _vm._v(",")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("lesseri, A. nemorosa, A. sylvestris")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuberous rooted")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("spring, early summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. coronaria")]), _vm._v(", "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("fulgens")]), _vm._v(", "), _c('em', [_vm._v("A. pavonia")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tuberous types ("), _c('em', [_vm._v("A. blanda")]), _vm._v(", "), _c('em', [_vm._v("A. coronaria")]), _vm._v(") are best planted in mid to late October, approximately 3\" deep. All species appreciate shelter from the afternoon sun and do poorly if allowed to dry out. The early spring-flowering tuberous species usually become dormant by the time the hot sun of the summer arrives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Confusion reigns about those ubiquitous Japanese anemones, which include a complex of closely related plants, none of which originated in Japan. It makes more sense to call them fall-flowering anemones. They include "), _c('em', [_vm._v("A. vitifolia")]), _vm._v(", "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(", "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" and "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(" and are all vigorous growers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by seed is possible but for most, division is the quickest and surest method of multiplication. For tuberous/rhizomatous species, the tubers may be lifted in early June and divided. Ripe seed should be rubbed in dry sand to remove the cottony down adhering to the seed. The autumn-flowering forms are easily increased by division in the fall. Root cuttings of the fibrous forms are commonly employed to propagate those species.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anemone Species")])])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Root")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Number of sepals")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. blanda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-14")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. canadensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. coronaria")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("7-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-11")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White, pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. multifida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-10")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. nemorosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sylvestris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("10-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-blanda")])]), _vm._v(" (blan' da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Grecian Windflower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Greece")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Grecian windflower is one of the earliest harbingers of spring. The plants’ small stature makes them suitable for naturalizing or for filling in small areas of the garden. Fernlike foliage arises from an oval tuber, followed by the flower. The narrow sepals are about 1/2\" long and the flowers nearly 2\" across. The flowers last but 2 weeks and then give rise to hairy seed heads known as achenes. These fruiting bodies persist for 3-4 weeks but are not particularly attractive and should be removed unless seeds are being collected. Although the flowers of the species are dark blue, cultivars are available in sky blue, white, pink or purplish red. Plant the tubers 1-3\" apart in dappled shade and in soil amended with organic matter. In the South (south of zone 6), plants do not spread as rapidly as in the North nor are they as long-lived. Regardless, plants will flower the first spring after planting, but one to two years is necessary to fully establish the tubers in the garden, especially if dried out when purchased. Once established, plants will self-sow and the seedlings will flower the next year. However, after all is said and done, given marauding critters like squirrels, chipmunks and voles combined with heat, drought and cold, an expectation of more than 3 years may be a tad unrealistic. They are inexpensive, buy some each year. Provide winter protection in zone 4 with leaves or pine boughs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Charmer’ produces deep rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Star’ has dark-blue flowers about 2-2 1/2\" in diameter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bridesmaid’ and ‘White Splendor’ both bear flowers of pure white. There is little difference between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Star’ and ‘Rosea’ have differing shades of purple. The former has larger flowers than the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Radar’ is one of the finest cultivars and has large mauve flowers with white centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Violet Star’ bears violet flowers with white centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Splendour’ has lovely single creamy white flowers.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone blanda")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-canadensis")])]), _vm._v(" (kan-a-den' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Meadow Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/spreader")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern United States, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name is particularly appropriate because the species will spread and fill an entire meadow. That it is somewhat invasive is probably its only flaw, and if placed in a difficult corner or other area where it can run, it will reign supreme in the spring and into early summer. The light green leaves are 5-7 parted and broader than long. They are hairy beneath and the leaf segments are toothed. Each clear white flower is almost 2\" across and consists of 4-5 sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants do best in partial shade but tolerate full sun. It is native to low-lying areas and thus requires moist conditions to become established. As long as its exuberant habit can be enjoyed, this is an excellent plant for those who think they can’t grow anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division any time from May to September.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-coronaria")])]), _vm._v(" (ko-ro-nah' ree-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Poppy Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("7-10\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poppy anemone is similar to Grecian anemone in that it is planted as a tuber and generally available from bulb catalogs or in colorful containers at garden centers.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Gardeners seldom see the actual species anymore, for it has been replaced with more colorful hybrids. All strains have finely divided foliage and rounded sepals in various colors. Regardless of the pedigree, they make lovely spring garden plants as well as excellent cut flowers. They may be planted in the North (zone 6) as late as October and in the South in November for early spring flowering. Further north than zone 6, pot the tuber at the beginning of March and plant outside after threat of frost, and flowers will emerge in late May and early June.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Research in Georgia (zone 7b) has shown that planting as late as December does not affect the number of flowers (4-5 flowers/plant). The flowering season was also extended a few weeks with late planting. However, plantings in January, February, and March resulted in very few flowers, all of questionable quality. This was probably because insufficient cold was accumulated by the tubers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This research also indicates that tubers are best treated as annuals, dug up and discarded after flowering. Flower production declines and tubers decline after two years in the ground. Like "), _c('em', [_vm._v("A. blanda")]), _vm._v(", tubers are inexpensive and can be replaced at nominal cost.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0089-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone coronaria")]), _vm._v(" ‘De Caen’")])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘De Caen’ hybrids were developed early in the 18th century around the Caen and Bayeux districts of northern France and became known as the De Caen anemones. The flowers are single, saucer shaped and available as ‘Florist Mix’ or as separate colors. ‘The Bride’, white; ‘Mr. Fokker’, violet-blue; and ‘Sylphide’, violet rose are only a few of the cultivars that were developed within the De Caen series. ‘Hollandia’ (syn. ‘His Excellency’) has scarlet sepals with white bases surrounding a black center and appears to be a cultivar of "), _c('em', [_vm._v("A. coronaria")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mona Lisa’ series is a strain of poppy anemone that is much preferable to the ‘De Caen’ series. Separate colors as well as a mixture have been developed. The flowers are larger, the stems are 1 1/2 to 2 times longer and the vase life of the cut flowers is longer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘St. Brigid’ series has semi-double flowers and is available as a mixture or in separate colors. ‘Lord Lieutenant’, purple blue, ‘Mt. Everest’, white, ‘The Admiral’, pink-red, and ‘The Governor’, crimson scarlet are available in this series.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hupehensis")])]), _vm._v(" (hew-puh-hen' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japanese Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are similar and often confused with "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")]), _vm._v(". This species has 5-7 rosy-mauve sepals, grows 2-2 1/2' tall and flowers a week or so earlier than the hybrid. It is generally shorter and may produce flowers that lack fertile pollen. Plants with 10-20 narrow sepals were found in 1695 in Japan, and finally sent to England in 1844 by Robert Fortune where they were called "), _c('em', [_vm._v("A. japonica")]), _vm._v(". Its proper name has finally been established as "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" var. "), _c('em', [_vm._v("japonica")]), _vm._v(", and has never been found in the wild except where it has been introduced. However, many fine cultivars belong to this variant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bodnant Burgundy’ has handsome dark flowers and stands 2-3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bowles’ Pink’ is hard to find in this country but has shown excellent performance in Europe. Single pink to rose-colored flowers occur in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Glow’ produces deep rose-pink semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hadspen Abundance’ has pink-rose single flowers with dark and light pink petals, and prominent golden-yellow stamens on 3' tall plants. Plants arose from Hadspen House, England.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pamina’ has proven to be an excellent addition to the Gardens at UGA, showing tolerance to heat and student abuse. The semi-double rose-pink flowers consist of overlapping sepals, and persist for weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Prince Henry’ has deep rose, semi-double flowers stands nearly 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Splendens’ has purple to pink flowers and is quite early to flower, up to 2 weeks earlier than other cultivars in some climates.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("hybrida")])]), _vm._v(" (hi-bred' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Anemone, Japanese Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2 1/2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White, Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The nomenclature of "), _c('em', [_vm._v("Anemone")]), _vm._v(" is rather confused but nowhere is it as befuddled as with Japanese anemone and the various hybrids, however, things are becoming ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("a little more clear. A few plants are still sold as "), _c('em', [_vm._v("A. japonica")]), _vm._v(", but those are actually hybrids. It now seems clear that almost all fall-flowering anemones have been lumped in this hybrid category, including favorites once classified as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" and "), _c('em', [_vm._v("A. vitifolia")]), _vm._v(". So far, only the closely related "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" remains split from the hybrids. I research these names long and hard, but like a sack full of puppies, the name game moves all over the place. There is no universal acceptance of this latest lumping, and in the next edition, everything may be changed again. So don’t get too concerned, especially with this group, because regardless of the name, the late flowerers are wonderful garden plants.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They are often slow to establish, but after the second or third year become free flowering and can often be overly aggressive. In the South, plant early in the fall to allow root establishment or early in the spring. Planting in midsummer is possible but often plants don’t establish well. They perform best in well-drained soils and partial shade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by division in the spring can be accomplished and is the easiest means of moving plants around the garden and avoiding overcrowding. However, root cuttings are also effective. Take thick sections of root approximately 3-4\" long from lifted plants and place vertically in a moist well-drained medium. Cover the tops of the root sections with a thin layer of sand or vermiculite and place in a cold frame or unheated greenhouse. This method of propagation should be accomplished when the plants are dormant in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some absolutely wonderful hybrids are available and although my preferences in anemones reside with the single forms, many cultivars are available with semi-double or double flowers. The only defect with many of the cultivars is that they are 4-5' tall and may need some support to look their best.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears single, clear white 2-3\" diameter flowers and stands 3' tall. This is often listed in catalogs but is probably the same as ‘Honorine Jobert’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alice’ has semi-double light pink flowers and is 2-2 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Andrea Atkinson’ is 3-4' tall with semi-double white flowers with chartreuse eyes. Plants bear handsome dark green foliage that makes the white flowers stand out even more.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Coupe D’Argent’ literally translates to “cut silver”.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elegans’ is early to flower and bears light pink single flowers that can be extraordinary in bloom. Plants may stand up to 4' tall and carry dozens of single, 3-4\" wide, clean pink flowers. The cultivars ‘Albert Schweitzer’ and ‘Max Vogel’ have been lumped into ‘Elegans’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elegantissima’ grows 3-4' tall and bears double rosy sepals. A tetraploid plant, it is very vigorous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honorine Jobert’ was a sport of the pink-flowered "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")]), _vm._v(" discovered in the garden of M. Jobert in Verdun, France in 1858. It has graced European gardens since the beginning of the American Civil War and is still the most popular and highly sought-after white anemone today. It is 3-4' tall and the clean white sepals contrast beautifully with the yellow stamens in the center. The flowers are only 2-3\" across, not as large as some of the newer clones, but the plant is floriferous and worthy of a place in the garden. It is difficult to know if you are purchasing this cultivar or ‘Alba’.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0092-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone x hybrida")]), _vm._v(" ‘Robustissima’"), _c('br'), _vm._v("Leaf"), _c('br'), _vm._v("Flowers")])])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("‘Kriemhilde’ is still one of the finest semi-double pink flowering cultivars available today with 10-15 broad overlapping sepals. Introduced in 1909.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loreley’ is seen more often in Europe but sometimes finds its way over here. Flowers are 3-4' tall with silvery pink semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Luise Uhink’ was bred by the German nurseryman Wilhelm Pfitzer, but is little known in this country. This is unfortunate as it has 3-4\" diameter semi-double white flowers on 4' tall stems and is a prolific flowerer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Margarete’ has semi-double to double deep pink flowers and is about 2-3' tall. Sterile flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Montrose’, introduced in 1899, bears semi-double to double deep rose sterile flowers on 3' tall stems. Flowers consist of about 40 slightly twisted narrow sepals. The cultivar ‘Lady Gilmour’ has been determined to be the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queen Charlotte’ bears lovely pink semi-double flowers which measure 3\" across. The tips of the sepals have a ragged appearance. It grows about 3' tall and was also bred by Pfitzer in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Richard Ahrens’ produces pink-lilac single to semi-double flowers that fade to almost white.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robustissima’ produces mauve-pink flowers held well above the foliage. The leaves are gray-green underneath. It is more winter-hardy than the species and can be grown in zone 4. Plants are robust, to the point of thuggery, in the shade, better behaved and quite tolerant of full sun. Plants are still offered as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" ("), _c('em', [_vm._v("A. vitifolia")]), _vm._v(") ‘Robustissima’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘September Charm’ is quite popular and with good reason. Plants produce an abundance of single rose-pink flowers that are darker on the outside than inside. Plants used to be classified as "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Victor Jones’ has single rose-pink flowers held up by 3-3 1/2' tall purple stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Whirlwind’ is 4-5' tall and produces 4\" wide semi-double pure white flowers consisting of 20-30 narrow flattened sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Giant’ grows to 4' tall and produces large semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-multifida")])]), _vm._v(" (mul-tee' fi-da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Magellan Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/6\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Chile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main claim to fame of this low-growing garden species is that it is one of the most cold-tolerant species of this genus, allowing gardeners from Alaska to North Carolina to enjoy it. The hairy leaves are much divided and plants are covered with numerous 1\" creamy-white flowers on 12\" long scapes. The seed heads (achenes) are densely hairy. Culture is not difficult in sun or light shade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Annabelle White’ grows about 12\" tall and is covered with creamy white flowers in early summer.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0094-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone")]), _vm._v(" ‘September Charm’")])])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-nemorosa")])]), _vm._v(" (nem-o-ro' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Wood Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wood anemones are widely distributed in Europe, absent only in the more southerly Mediterranean areas, so it should not be surprising that plants are extremely variable in size, color, and even structure of the flowers. There are usually 5-8 sepals, but forms lacking sepals, and those with 50 or more are known. The flowers are about 1 1/2-2\" wide and often tinged rose on the margins. The solitary stems bear leaves halfway up, and terminate in a solitary flower. The common flower color is white, but a number of clones have blue or pink flowers and a yellow-flowered variant has also been described.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foliage is three times divided into deeply toothed linear segments. Plants arise from a wormlike rhizome that branches extensively beneath the ground. "), _c('em', [_vm._v("A. nemorosa")]), _vm._v(" performs best in slightly acid soil (pH 5.5-6.5) containing liberal amounts of peat or leaf mold and in dappled to deep shade. Plant in fall only.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many cultivars and varieties have been described but not all are easily found.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Blue flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("allenii")]), _vm._v(" is about 1' tall and has large (2\" diameter), deep lavender-blue flowers. The reverse is streaked with purplish red dots of varying intensity.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Beauty’ is the tallest of the blue forms growing 15-18\" in height and bears perfect sky blue cup-shaped blooms. It is the best blue form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bowles’ Mauve’ has lavender-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("caerulea")]), _vm._v(" is about 6\" tall with sky blue 3/4\" wide flowers. The flower reverse is paler blue. Perhaps all the blue forms should be lumped under this category, as there is little difference between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robinsoniana’ has 1 1/2\" diameter bright lavender-blue flowers. It grows 12-14\" tall and is one of the oldest varieties still offered by perennial growers. Probably discovered by William Robinson in Oxford Botanical Garden, having “been sent there by a lady in Ireland”.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Pink flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("rosea")]), _vm._v(" is 10-14\" tall and carries nodding 1\" wide light rose flowers with a paler reverse. It is slow to increase vegetatively and seed production is poor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("White flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore Pleno’ (‘Alba Plena’) stands 10\" tall and has semi-double to double flowers. It is an excellent garden plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("grandiflora")]), _vm._v(" has the largest flowers, sometimes attaining 3\" in diameter. Plants are vigorous and grow 20\" tall in rich soil.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady Doneraile’ is similar to ‘Lychette’ but only 10\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lychette’ is one of the best white-flowered cultivars, bearing large 2\" diameter flowers that are pure white above and beneath. There are green blushes around the bases of the 6-8 sepals. I have seen plants grow up to 20\" tall, but they are normally 10-12\" in height.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("‘Vestal’ has pure white sepals surrounding a center filled with broad stamen filaments (petaloid stamens). Closely resembles ‘Flore Pleno’ but the flowers are larger ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("and petaloid segments are more regular. They are different but in commerce, I am not sure what is being sold out there.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Viridifolia’ is for those gardeners who can’t get enough green. Flowers consist of dozen of green bracts making it look like the Jolly Green Giant on a bad hair day. However, since it flowers in early spring, there is not a lot of green competition at the time, so it is certainly interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sylvestris")])]), _vm._v(" (sil-ves' tris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Snowdrop Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("10-18\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have been in a Denver snowstorm in March and the next day seen these plants push through the white stuff as if it were no more than a minor nuisance. One of the prettiest spring anemones, it combines light green, 3-5 parted leaves with fragrant 1 1/2-2\" diameter, dainty, white flowers. The 5-sepaled flowers are slightly nodding when fully open and are solitary on the flower stalk. The lovely flowers give way to interesting white, woolly fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sylvestris")]), _vm._v(" requires light soil and a partially shaded area for best performance. The major drawback is that it runs freely, particularly in loose soils, and can overrun less aggressive plants. Plantlets, however, are not difficult to remove and gardening friends will be more than happy to accept a few. It visits me every now and then in Athens, but without doubt is more comfortable in Denver and Montreal. Cold weather is to its liking and it is more aggressive in northern climates than in the South.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Compacta’ is offered by a few nurseries and is a more dwarf, more compact form of the species. I have never found the species to be particularly large or in need of compaction, but such is the benefit of diversity.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("macrantha")]), _vm._v(" has larger and more abundant flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elise Feldman’ is a relatively new introduction with almost fully double white flowers in the spring. The flowers are quite heavy and may fall over in inclement weather. Similar to ‘Flore pleno’, perhaps more consistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore pleno’ is a double-flowered white cultivar but is not nearly as pretty as the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dozens of species and hybrids are sold and can be dramatic additions to the garden. Most are more difficult to locate, and some may disappoint a little, but for the anemone enthusiast, there is no such thing as a bad anemone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. altaica")]), _vm._v(" is a tuberous form native to northern areas of Russia and the Arctic and therefore particularly cold hardy. Plants are about 8\" tall and bear single white flowers with blue or purple veins in the spring. Great for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. apennina")]), _vm._v(", Apennine windflower, is also tuberous and has a similar form to "), _c('em', [_vm._v("A. altaica")]), _vm._v(", but is not as cold hardy. Plants have larger leaves and bright blue spring flowers with yellow stamens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. leveillei")]), _vm._v(" has kidney-shaped leaves basal leaves divided into three sessile lobes, each divided deeply. Plants grow 15-18\" tall. The 1-2\" wide white flowers are stained blue to pink on the outside. Hardy to about zone 6.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('em', [_vm._v("A. multifida")]), _vm._v(" is native from Alaska to Quebec and Saskatchewan and south to California and Colorado. This fine native species forms 8-12\" high mounds of light green delicately cut foliage with two to three long stalked yellowish flowers in early spring. Flowers may be clear red or tinged with blue or purple. The styles are red or pink, and silky seed heads add additional interest after flowering. Some handsome colonies occur in the alpine area of the Denver Botanic Garden. ‘Major’ is better than the species due to the larger creamy yellow flowers. ‘Magellanica’ is taller, growing 18-24\" in height. Plants perform well in zones 3 to 6 as well as in the Northwest. Poor choices for the South.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. narcissiflora")]), _vm._v(", native to the mountains of Europe and Japan, grows about 12-18\" tall over deeply divided foliage. Plants bear 2-6 white to cream-colored flowers in an umbel in the spring. Each flower is about an inch wide. Plants do well in zones 4 to 7a.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pavonina")]), _vm._v(" is native to southern Europe, mainly around the Mediterranean, and also arises from a tuber. Plants grow about 9-12\" tall and bear solitary 2-3\" wide flowers in the spring. The flowers, consisting of 7-9 segments, are often scarlet, however pink, purple and violet colors occur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. quinquefolia")]), _vm._v(", American wood anemone, was initially considered to be a variety of "), _c('em', [_vm._v("A. nemorosa")]), _vm._v(" ("), _c('em', [_vm._v("A. n")]), _vm._v(". var. "), _c('em', [_vm._v("quinquefolia")]), _vm._v("). It is native from Quebec to Georgia and common in moist rich woodlands. The white flowers are 3/4-1\" across and appear in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rivularis")]), _vm._v(" is native to India and China and grows up to 3' tall in zones 5-7. The white flowers are stained blue throughout and are borne in 3-5 flowered umbels in late spring and summer. It is a terrific plant, particularly suited around semi-shaded ponds and water features.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rupicola")]), _vm._v(" is another white-flowered species with blue or pink staining on the sepals but is only about 6-9\" tall. The basal leaves are three parted and strongly lobed while the solitary flowers are up to 2-3\" across. Hardy in zones 4-7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. virginiana")]), _vm._v(", thimbleweed, is a native woodland species with greenish white to white 1\" wide flowers. The early spring flowers usually occur in 3's and consist of 5 sepals. Plants grow about 2' tall and are particularly suited to the woodland garden. Thimbleweed is hardy from zones 3 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemonella")])]), _vm._v(" (a-nem-o-nell' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rue-anemone")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The rue-anemones have to be one of the prettiest diminutive woodland plants for the garden. They are native to a large slice of North America, from southwest Maine to northern Florida, west to Minnesota and Oklahoma. The genus is represented by "), _c('em', [_vm._v("A. thalictroides")]), _vm._v(" only. Many taxonomists have transferred the species to "), _c('em', [_vm._v("Thalictrum")]), _vm._v(" ("), _c('em', [_vm._v("T. thalictroides")]), _vm._v(") but the jury is still out, so I’ll leave it here for now. Plants with an eastern nativity tend to be white but as the plants extend west, flowers appear to have more pink in them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("In woodland gardens throughout the eastern United States, rue-anemone is a welcome and familiar sight in early spring. And in the Armitage garden, plants compete with the roots of a large white oak without complaint, and make the base of that noble tree even better. Plants grow about 8-10\" tall and bear foliage similar to anemone, except much daintier and finer. They are blue-green, basal and 1-2 ternate, ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("each terminal leaflet being 3-toothed at the apex. The 1/2\" wide flowers are arranged in 2-5 flowered umbels and consist of 5-10 petal-like sepals and numerous stamens. There are no petals.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemonella thalictroides")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("They love to be grouped in partially shaded areas with moisture-retentive soils. If they dry out, they look ratty early. With the exception of slugs, few diseases or insects bother them. Plants are hardy in zones 4-9. By the way, the suffixes “opsis”, “ella” and “oides” means “looks like”; this plant resembles both an anemone and a thalictrum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by seed or division of well-developed clumps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been an explosion of cultivars in the last few years. None of them is inexpensive but I see an “Anemonella Stage of Life” coming to a few gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Betty Blake’ produces light green to yellow green double flowers and flower for a long period of time.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cameo’ is a light pink-flowered double form. They are similar in form to ‘Schoaf’s Double Pink’ but differ by having much lighter-colored flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Double White’ is similar to ‘Cameo’ but with cleaner white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eco Pink’ from Don Jacobs of Eco-Gardens in Decatur, Georgia, has single pink flowers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("‘Eco Starry Night’ has unique pointed sepals and bronzy foliage. Quite different.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eco Atlas Double’ bears white pompon double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("favilliana")]), _vm._v(" is a handsome double white form. Flowers persist much longer than the species but plants are slow to increase. Difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jade Feather’ is also known as ‘Green Dragon’ or ‘Green Hurricane’. Regardless of the name, they are scary. The plants produce strange double flowers with twisted green sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ bears single light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Schoaf’s Double Pink’ bears double rose-pink flowers. It was the result of a chance sighting by a Mr. Oscar Schoaf in a graveyard in Owatonna, Minnesota. While Mr. Schoaf brought the plants into cultivation in his garden, it was Mrs. Louise Koehler of Bixby, Minnesota who sent plants to friends and nurseries and so brought the plant out of obscurity. Propagated only by division, plants are slow to increase but now are relatively easy to locate. Like other anemonellas, they are expensive, but they are worth the hunt. They are stunning in Garden in the Woods, Framingham, Massachusetts.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tairin’ has deep pink to rose single flowers and performs well for a long period of time in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemonopsis")])]), _vm._v(" (a-nem-o-nop' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("False Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("As I stared at this plant in a shady Cleveland garden, I knew the glossy foliage looked like an anemone but I couldn’t for the life of me place the flowers. All I could say to my inquisitor about this most handsome plant was that it looked like an anemone. It turned out to be a pretty good guess when one considers that the name "), _c('em', [_vm._v("Anemonopsis")]), _vm._v(" is translated “resembles anemone”. Only one species, "), _c('em', [_vm._v("A. macrophylla")]), _vm._v(", native to Japan, has been described and it is occasionally offered by specialty nurseries. The 1\" wide waxy lavender-pink flowers are held in loose racemes well above the glossy green basal leaves. The pendulous flowers occur in late summer and are particularly lovely if plants are planted on a bank where the flowers can be viewed from beneath. Partially shaded, moist conditions serve plants well. A terrific garden plant, they likely perform well in zones 4-7. Propagate from seed or division.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Angelica")])]), _vm._v(" (an-gel' i-ca)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Angelica")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Apiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Plants are better known for their medicinal properties than as an ornamental garden plant. The 50 or so species are found in the northern United States and Canada to Japan and Europe. In general, they are tall and stout, and at home in semi-shaded moist areas. The leaves are in 3’s (ternate) to pinnate and the petioles are usually sheathed around the stem. The garden forms available are impressive but often short lived.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick reference to Angelica Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. archangelica")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Creamy-white")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. gigas")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('a', {
    attrs: {
      "id": "page_100"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-archangelica")])]), _vm._v(" (ark-an-gel' i-ka)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Wild Parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("5-6'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Creamy-white")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Say the name "), _c('em', [_vm._v("Angelica archangelica")]), _vm._v(" a few times and it begins to take on poetic qualities of its own. The specific name came from the Archangel Raphael. As you know archangels are high-ranking angels, and Raphael was charged to heal the earth. St. Raphael has a special charge of protecting the young, the innocent, and travelers. The Feast of St. Raphael is October 24.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant has been cultivated for generations in Asia and Europe for its confectionery properties and as a vegetable. The stems and petioles may be crystallized for candying and the young shoots are prepared similar to asparagus or cooked with rhubarb, to reduce the tartness. However, let not your taste or lack of it for rhubarb limit the use of this plant! As a cultivated plant, it lends a stateliness of its own to the garden. The large, flat, creamy-white to greenish compound umbels are handsome enough but the resulting seed heads can be absolutely majestic. These large plants can take over an area and will reseed if allowed to do so. Plants are monocarpic, meaning they die after seeding. Some gardeners have found that removing the flowers before they go to seed increases the chance of perennialization. Seedlings require two years to flower.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-gigas")])]), _vm._v(" (gee' gas)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple Parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late summer, Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan, Korea, China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Introduced to this country from Korea by Barry Yinger of Asiatica Nursery, this large coarse plant never fails to draw attention when in flower. The light green leaves are attached to the thick stems with inflated purple sheaths. The flowers are deep purple, in umbels 3-4\" across. Similar to the above species, the drying seed heads are also magical. Although tolerant of shade, if placed in too heavy shade, the dark flowers get lost. Plants love moisture and will be stunted in dry summers. Only recently finding its way into American nurseries, this is an exciting biennial plant for the late summer and fall garden. Plants will self-sow in favorable conditions and may be considered a “perennial biennial”. Seed-grown plants generally require two years before flowering. In the shaded Armitage garden, plants were magnificent in June into July although the seed heads never developed as well as I would have liked. The quality of the seed heads increases with sunny areas, cool night temperatures and low humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. keiskei")]), _vm._v(", otherwise known as ashitaba, is a medicinal herb from Japan. I grew this in the Gardens at UGA and was most impressed with the ornamental value. The plants were robust, but compact, never growing taller than 2 1/2'. However, the foliage was glossy, shiny green and always caught the eye. Plants shone even more as temperatures became cooler and in our zone 7 climate were at their best in the fall, winter and spring. The flowers were white. Most of the time plants behave like a biennial and once flowered, it will disappear. However, I have seen this in John Elsley’s garden in Greenwood, South Carolina and he claims it was there for at least three years.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0101-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Angelica gigas")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_c('em', [_vm._v("A. pachycarpa")]), _vm._v(" also has glossy green leaves and is also a biennial. Leaves are smaller and plants are more branched. Plants grow 4-6' tall, and are wonderfully ornamental.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Antennaria")])]), _vm._v(" (an-ten-ar' i-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Pussytoes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 15 species are used in gardens, primarily because of the gray foliage that carpets the ground. The flowers are dioecious, meaning that male and female occur on separate plants. The actual flowers are nondescript but are surrounded by dry, chaffy scales which provide the color. However, the gray foliage is the most valuable garden asset.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Plants tolerate poor infertile soils and hot, dry locations. They are best suited for the front of the garden or rock garden. Pussytoes are gaining a steady following due to their toughness, their well-behaved habit and the gray-silver foliage. Some of the more common forms are native to Europe, however, a number of good species call ")]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("North America home. "), _c('em', [_vm._v("A. neglecta")]), _vm._v(" var. "), _c('em', [_vm._v("gaspensia")]), _vm._v(" is one of the neatest, bearing small silvery leaves on 2-3\" tall ground-hugging mats over which rise silvery-white flowers. "), _c('em', [_vm._v("A. parvifolia")]), _vm._v(", Contock pussytoes, native to southwest Canada and the western United States is also an excellent rock garden plant.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-dioica")])]), _vm._v(" (die-o-i' ka)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Pussytoes")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-10\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants send up crowded corymbs of light green flowers with pinkish tips that resemble the toes of your favorite pussycat. The spatulate basal leaves are about 1\" long and gray-green (some call them silver). The foliage becomes less gray-green as the season progresses and may be almost green by midsummer. The stoloniferous plants fill in rapidly and are occasionally used as an herbaceous lawn by more creative gardeners. If not used as a ground cover, they should be divided every 2 years. Plants are tolerant of poor soil but good drainage is necessary to reduce root rot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division in the spring or by seed. The seeds are small and should be mixed with fine sand to insure even distribution in the seed tray. Provide temperatures of about 72-75°F and maintain consistent soil moisture. Transfer seedlings to 60°F conditions for subsequent growth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Devil’s Tower’ is about 4\" tall with silver leaves and pink flowers. Available from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("hyperborea")]), _vm._v(" (var. "), _c('em', [_vm._v("tomentosa")]), _vm._v(") produces wide, densely hairy leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("minima")]), _vm._v(" (‘Minima’) is only about 1\" tall and forms a dense carpet. Best for containers or sunny rock gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("minima rubra")]), _vm._v(" is similar to the above but bears rosy red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nyewood’ is a more compact and slower-growing form than the species. The cherry-red flowers cover the tight silver-gray leaves in late spring to early summer. About 3\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("rosea")]), _vm._v(" (‘Rosea’) and var. "), _c('em', [_vm._v("rubra")]), _vm._v(" (‘Rubra’) have pink and rosy red flowers respectively and are 8-10\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. plantaginifolia")]), _vm._v(", ladies’ tobacco, is an interesting if not dramatic native species. The basal rather smooth leaves have three to seven conspicuous veins, resembling those of plantain. From this basal rosette arise the light tan tight flower heads on 8-12\" tall stems, which slowly form a colony of gray-green foliage. Useful in zones 3 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rosea")]), _vm._v(" ("), _c('em', [_vm._v("A. dioica")]), _vm._v(" ‘Rosea’), rose pussytoes, is the most common offering and produces rose-pink flowers on 8\" tall plants. The leaves are a little thinner than those of "), _c('em', [_vm._v("A. dioica")]), _vm._v(". The fluffy rose-pink flowers rise well above the permanently gray-green foliage in late spring and early summer. Native to the mountains of western North America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rupicola")]), _vm._v(" is native to the northeastern United States and forms 2-3\" tall loose mats of gray-green foliage which turn beet red in the fall.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "id": "page_103"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anthemis")])]), _vm._v(" (an' them-is)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Golden Marguerite")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of the 80 species in the genus, only a few are worth growing and fewer yet are easily available in the United States. All have strongly scented, alternately arranged foliage that is divided 2-3 times. Flowers of some species such as "), _c('em', [_vm._v("A. punctata")]), _vm._v(" are white, and many hybrids also\nsport white ray flowers. However most of the species of anthemis have yellow or orange flowers borne singly on long stems. All need full sun and well-drained soils for best results. Most tolerate relatively poor soils and, in fact, become too leggy if fertilized heavily. The genus is most suitable for northern climates and while "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" prospers during spring and early summer in southern gardens, it usually collapses into a messy heap making it rather useless south of zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is easy by division and is necessary within 2-3 years for all species listed. Seeds germinate readily and are available for some cultivars of "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anthemis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. punctata subsp. cupaniana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. marschalliana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Silver-green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tinctoria")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-punctata")])]), _vm._v(" (punk-tah' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sicilian Chamomile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-12\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The species is handsome enough but the only plant offered is subspecies "), _c('em', [_vm._v("cupaniana")]), _vm._v(". Scientists have been battling over this plant for a good while but for now, this is its taxonomic slot. Plants form sprawling gray-green mats that remind me of lacy artemisia and provide wonderful contrasts to other plants in the garden. They are most useful as edging or placed strategically at the front of the border or as an integral part of the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1-2\" diameter white daisies consist of 20-25 rays around yellow centers and are borne on 10-12\" stems. The flowers are nothing to write home about but the contrast with the ferny, aromatic leaves is terrific. This subspecies remains relatively compact compared to others in the genus. Good drainage helps prevent plants dying during cool, rainy winters. If plants are not in flower and you are not sure if you are looking at "), _c('em', [_vm._v("Anthemis")]), _vm._v(" or "), _c('em', [_vm._v("Artemisia")]), _vm._v(", simply smell the foliage. The characteristic artemisia scent is totally lacking.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-marschalliana")])]), _vm._v(" (mar-shal-ee-ah' na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Marschall’s Chamomile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("Plants are dressed in finely divided silvery foliage atop which are borne 1-2\" diameter golden yellow daisy flowers. The pinnately segmented foliage has long hairs and is silky to the touch. If spent flowers are removed immediately, flowering will continue ")]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("throughout the summer. This is a better species for the South than "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(". Excellent drainage is necessary and full sun is best but some afternoon shade is tolerated. subsp. "), _c('em', [_vm._v("biebersteiniana")]), _vm._v(", named for Baron Friedrich August Marschall von Bieberstein, is even more silvery and more compact.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tinctoria")])]), _vm._v(" (tink-to' ree-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Golden Marguerite")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the most common "), _c('em', [_vm._v("Anthemis")]), _vm._v(" available and, with proper culture, is a magnificent plant in the northern United States and Canada. The 3\" long toothed leaves look a little like parsley and are somewhat downy beneath. The stem is not round but angled and the 1 1/2\" diameter flowers are single, yellow and plentiful, even if rather short-lived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If grown in rich soil, plants often grow 3' tall and require staking. Do not fertilize heavily or the plants will be a mess. Cut back severely after flowering to encourage basal growth, and divide every 2 years. Sharon Illingworth, of Thunder Bay, Ontario, Canada takes cuttings from overwintered young shoots in early spring and roots them in vermiculite covered with plastic bags. Roots are formed within 14 days and good-sized plants for transplanting result by early June.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("A. tinctoria")]), _vm._v(" and "), _c('em', [_vm._v("A. sancti-johannis")]), _vm._v(" (a similar species with deep orange-yellow flowers) have hybridized freely and some of the listed cultivars may be hybrids between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is very un-alba-ish, bearing pale cream-colored flowers over dark green finely divided leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘E. C. Buxton’ (‘Buxton’s Variety’) is a superb 2-2 1/2' tall cultivar which bears off-white daisies with lemon yellow centers. Probably still the best of the "), _c('em', [_vm._v("Anthemis")]), _vm._v(" cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beauty of Grallagh’ includes plants sometimes sold as ‘Grallagh Gold’ and ‘Grallagh Glory’. Plants may bear bright gold to pale yellow to yellow-orange flowers atop 3' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kelwayi’ (‘Kelway’s Variety’) has been popular for many years. Plants bear a profusion of bright yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moonlight’ bears handsome light yellow blossoms with a deeper yellow center.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sauce Hollandaise’ bears pure white ray flowers surrounding yellow centers. Grows about 2' tall. Cheryl Greenwood Kelly of Washington State University compares the flowers to “softly poached eggs; a feast for the eyes”. I have seen a plant listed as ‘Sauce Béarnaise’ but can not find it sold anywhere. I will let the chefs sort this one out.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Suzanna Mitchell’ bears silver-green mounds of feathered foliage and light cream yellow ray flowers surrounding gold centers. Plants are about 2' tall, cold hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘St. Johannes’ has bright orange flowers. The three previous cultivars are more compact than the species but even more dwarf cultivars would still be most welcome.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("‘Tetworth’ is a welcome addition to this plant group. A hybrid between "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" and "), _c('em', [_vm._v("A. punctata")]), _vm._v(" subsp. "), _c('em', [_vm._v("cupaniana")]), _vm._v(", plants bear the gray foliage and small stature of the latter but the profusion of flowers of the former. The semi-double white daisies are produced in early summer on 10-18\" tall plants.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wargrave’ bears masses of pale yellow daisy flowers and deep green ferny foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. carpatica")]), _vm._v(" ("), _c('em', [_vm._v("A. cretica")]), _vm._v(" subsp. "), _c('em', [_vm._v("carpatica")]), _vm._v(") forms 6\" tall cushions of gray-green hairy foliage and white daisy flowers. ‘Snow Carpet’ occasionally appears in catalogs. It seems to be the same as the above but is a much better name. Hardy from zones 3-7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. triumfetti")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" but carries many handsome white flowers with yellow centers. Plants grow 18-24\" tall. Likely hardy only to zone 6 or 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anthericum")])]), _vm._v(" (an-ther' i-cum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("St. Bernard’s Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asphodelaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 50 species of this little-used genus are known but two are cultivated with some success in North America. Plants emerge from rhizomes, and flowering occurs in late spring and summer. All species are native to southern Europe, Turkey or Africa. Not easy to locate but well worth a spot in the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anthericum Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower stem branched")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. liliago")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ramosum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-liliago")])]), _vm._v(" (lil-ee' a-go)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("St. Bernard’s Lily")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-30\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Native to alpine meadows, where it bears racemes of small, starry white flowers in the late spring or summer garden. The flowers are even more handsome up close where the upwardly curled styles and yellow stamens can be admired. Plants will grow 2-2 1/2' tall, but for best results, plant in groups of at least three. Full sun and well-drained soils are necessary. Plants do not perform well in the South.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Major’ is taller (3') than the species and bears flattened pure white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ramosum")])]), _vm._v(" (ray mo' sum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Native to lower valleys than "), _c('em', [_vm._v("A. liliago")]), _vm._v(", this species is a little more heat tolerant and a better choice for hot summers. The gray-green upright foliage combines with many white flowers on a branched inflorescence. The flowers have yellow stamens and straight styles. Full sun and well-drained soils help make this plant successful in the garden.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aquilegia")])]), _vm._v(" (ack-wi-lee' gee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A garden without columbine is simply unacceptable. The genus consists of approximately 65 species, and if all were available, they would probably all be outstanding garden plants. The flowers, which may be nodding or upright, consist of 5 petals with a short broad tube in front (petal tube) and backward-projecting spurs. The spurs were thought to resemble the claws of an eagle, the Latin translation being "), _c('em', [_vm._v("aquila")]), _vm._v(", thus the genus name. They are useful determiners of a species, in that some are reasonably straight, in others, the ends are hooked like a fish hook, yet others are curved. The 5 sepals are often the same color as the petals but may be different in some species and hybrids. After flowering, the seed is held in erect long, narrow follicles that are ornamental for many weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are held in groups of 3 leaflets (ternate), and in some species they are arranged in two groups of three (biternate). The leaves are always attached to the stem by long petioles. All columbines are spring or early summer flowering and perform best in a rich soil, light to moderate shade and with plenty of moisture. Many columbines are short lived, particularly if drainage is poor, and considered a bonus if they return after two or three years (although many reseed).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Species vary considerably, ranging from 3' tall species to miniatures, and vary in color from white to blue and purple to pink. In fact, for those gardeners who can’t control their columbine habit, there is even a green-flowered species, "), _c('em', [_vm._v("A. viridiflora")]), _vm._v(", which no one will like but you. The white-flowered "), _c('em', [_vm._v("A. fragrans")]), _vm._v(" is even sweetly fragrant. Several columbines reseed freely, particularly "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" and "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(". Natural hybridization occurs among species, so they should be planted in separate areas of the garden if one does not want illegitimate seedlings among the parents. In general, the hybrids do not come true from seed, however, many of the chance off-spring that do result are handsome in their own right and often quite vigorous. Many gardeners, myself included, feel that the hybrids are not nearly as stately as many of the species; however, they do satisfy the needs of the “bigger is better” crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A huge amount of confusion still exists as to what cultivar and hybrid belong under what species. A trial of 96 columbines in 2003 by the Royal Horticultural Society found that nearly one-third were incorrectly labeled. Many of the cultivars and series are raised by one company and then introduced, often under different names, by one or several other companies over a short period. In our studies at the Gardens at UGA, we have seen the same problems, where one series is essentially the same as another, but with a quite different name. As a gardener, I really do not fret about it; as a researcher, it rots my socks. However, I have listed cultivars and hybrids to the best of my ability; someday DNA profiling will sort it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nearly all the hybrids, cultivars and species are grown from seed. Propagation from seed is not difficult, however most respond to a cold treatment. Sow the seed in a well-drained medium, place in the cold (a refrigerator will do) for about 6 weeks. Many of the named cultivars of the hybrids as well as species may be purchased from seed.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aquilegia Species")])])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower Color (sepals/petals)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Spurs straight (S) hooked (H) curved (C)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Spur length (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower nodding (N) upright (U)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/blue (white)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caerulea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/white")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. canadensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/red")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. chrysantha")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/pale yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-2 1/2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. flabellata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White/white")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C,H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. longissima")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/pale yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. vulgaris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-3/4")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpina")])]), _vm._v(" (al-pine' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Alpine Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species belies its name as some of the most vigorous and stately plants in the Armitage garden have been "), _c('em', [_vm._v("A. alpina")]), _vm._v(". Most columbines will be a little taller in the South compared with the same plants in the North and this one is usually only 1-1 1/2' in northern areas but is 2 1/2-3' in the South. The gray green foliage is deeply divided into linear lobes. The basal leaves are biternate and the stem is hairy, particularly near the top. The abundant nodding flowers have short curved or slightly hooked spurs, flared 2\" wide sepals, and are usually blue throughout, although the petal tube is occasionally white. This is, without question, one of the finest classic columbines available for the garden. Plants often reseed, providing years of enjoyment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation from seed is easy and although a cold treatment is beneficial, it is not necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("alba")]), _vm._v(" is a white form whose flowers contrast well with the dark green foliage. It grows a little shorter than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Atroviolacea’ bears purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Spurs’ is taller and has longer spurs than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("superba")]), _vm._v(" is larger than the species but otherwise similar.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-caerulea")])]), _vm._v(" (ce-ru' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rocky Mountain Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue/White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rocky Mountains")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("This long-spurred blue and white-flowered species really isn’t much different than many of the hybrids of the same color but to encounter a stand of these flowers in the spring mountain meadows is close to a religious experience. The state flower of Colorado bears large (2-3\" across) upright-facing flowers and has been an important ")]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("parent in the development of long-spurred hybrids. The spurs are straight or outward curving and are often tipped with green. Although not as vigorous as many of the other species or hybrids, it is longer lasting, 4-5 years in the garden not being uncommon. Propagation is similar to "), _c('em', [_vm._v("A. alpina")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0108-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia caerulea")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some catalogs provide an impressive list of cultivars but most belong with the hybrids, of which "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" is only one of the parents.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mrs. Nicholls’ has 3\" wide Cambridge blue outer petals and whitish blue inner petals. It is an old cultivar and, unfortunately, difficult to find.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("ochroleuca")]), _vm._v(" (syn. ‘Albiflora’) has creamy white flowers but is otherwise similar to the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Hobbit’ is an "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" hybrid having been selected from ‘Crimson Star’. Rose-red flowers are produced on a compact 12-15\" tall plant.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("‘Rose Queen’ produces large long-spurred rose and white flowers.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-canadensis")])]), _vm._v(" (kan-a-den' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Canadian Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow/Red")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of my all-time favorite spring-flowering plants. To be sure, they are not as spectacular as many of the hybrids but have a certain grace and elegance that puts them in a class of their own. People in North Carolina certainly appreciated it when they named it the North Carolina Wildflower of the Year in 1987. Native to much of eastern North America, they are found in moist, shady areas. Plants look best in clumps of three or more and reseed to double the area within 2-3 years. The 1 1/2\" long nodding flowers appear in early spring and remain in bloom for approximately 6 weeks. The short spurs are slightly curved but do not have the obvious hook seen in "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" or "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". In my garden, plants range from light pink/yellow to blood red/yellow. In climates with cooler nights the sepals are decidedly redder. Plants have somewhat evergreen foliage in southern climes and new growth begins as soon as temperatures rise above 40°F. Due to its vigor, this is one of the few columbines that can be placed at the back of the bed or used to hide a distracting object such as an electrical box or fire hydrant (although my dog Hannah was not fooled and learned the meaning of respect).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia canadensis")])])]), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("This species also shows a relative disdain for that voracious enemy of columbine—the leaf miner! Based on observations over the years, there is little doubt that when grown side by side, "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" is less susceptible to leaf miner damage than many other species and certainly much more so than the hybrids. Leaf miners will mine this species also and eventually cause significant disfiguration, but not as rapidly as with others.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by seed is easy. Do not be surprised to find plants emerging quite a distance from the initial planting. If fresh seeds are needed, wait until the seeds loosen and turn jet black. One of the favorite projects in my perennials class at Georgia is to place each student beside a plant in my garden just after the seeds have ripened in their cozy follicles. The assignment is to gather the seeds and fling them around the garden, leaving a legacy for the student and increasing my harvest for next spring. Everyone gets a grade of A; no worries about grade inflation here. Plants flower the second year from seed. Thinning the seedlings by transplanting young plants rejuvenates the clump as well as increases numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Corbett’ was selected by Richard Simon of Bluemont Nursery in Monkton, Maryland. This happens to be near another quaint town called Corbett, Maryland, a town in which the Clemens family lived. In the late 1960s, two young brothers, Andrew and Larry Clemens, went walking in the woods near their house, found some short yellow columbine plants, and brought them home. Their mother Shirley eventually shared some seed with their neighbor, Richard Simon, who introduced it under the town name approximately 25 years later. It is one of the great stories of American gardening, reaffirming the axiom “If you want to save a plant, share it with others.” Plants grow 8-10\" tall and bear pale yellow flowers. It is not as vigorous as the species and does better in areas of cooler nights. I still love it.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little Lanterns’ is a dwarf form of the species, mirroring flower color, foliage and vigor, except that plants are no more than a foot tall. This is very similar to, or the same as, ‘Canyon Vistas’. I cannot tell the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-chrysantha")])]), _vm._v(" (kris-anth' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Golden Columbine, Texas Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Mexico, Arizona")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flower size of Texas columbine is the antithesis of those of Canadian columbine, figures, eh? Although not possessing flashy colors, it is probably one of the most spectacular columbines when in flower, particularly when planted against a blue-flowered background. My students pointed out that my plants would probably be a little easier to see if they were not planted in the middle of late yellow daffodils. I have to find that darn color wheel. The flowers are 2-3\" across and the petals are a deeper yellow than the sepals. The 3\" long spurs spread away from the flower. This is a tall, loose grower that has been used as one of the parents of the long-spurred hybrids. If provided with sufficient moisture, no staking should be necessary.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba-plena’ has very pale yellow (almost white) flowers that are occasionally tinged with pink and about 1 3/4\" across.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Denver Gold’ is likely the same as var. "), _c('em', [_vm._v("hinckleyana")]), _vm._v(", but has a better name. A 2001 Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" winner.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("hinckleyana")]), _vm._v(", Hinckley’s columbine, is native to Texas and is more compact than the species. Seems to be more persistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("jaeschkanii")]), _vm._v(" and "), _c('em', [_vm._v("nana")]), _vm._v(" are dwarf varieties (1 1/2' tall), the former bearing yellow flowers and red spurs while the latter is the same color as the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Queen’ has 3\" diameter white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Yellow Queen’ bears 2-3\" wide lemon-yellow flowers. This is a great plant, and looks even better when combined with blue or gray-foliaged plants. In the 2003 trials of the Royal Horticultural Society, this cultivar was presented the Award of Garden Merit.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-flabellata")])]), _vm._v(" (flay-bel-lah' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fan Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-18\"/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are unique in that they are thicker and bluer than most species and the fan-shaped, round leaf segments often overlap. The overlapping leaf segments and the bluish tinge to the leaves make this one of the easiest species for my students to identify and separate from the other dozen columbines I throw at them. Plants have been described as “squat or short and fat”, however, the term compact is kinder and more accurate. It is an excellent plant for the front of the garden or the rockery. The species bears lilac to blue flowers and the spurs are curved to hooked. The terminal flower opens first followed by those in the lower axils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is the most common form offered by nurseries. The creamy white nodding flowers are often tinged pink.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("pumila")]), _vm._v(" is the dwarf form of the species. var. "), _c('em', [_vm._v("pumila")]), _vm._v(" forma "), _c('em', [_vm._v("alba")]), _vm._v(", (‘Nana Alba’, ‘White Angel’) has white flowers. Expect to see these sold as ‘Dwarf’ or ‘Dwarf White’, or whatever creative terms are most marketable to garden centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cameo series consists of short compact forms, all of which do well in the shaded garden. The best are blue-white and pink-white. ‘Cameo White’ does not appear to be as vigorous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fantasy series is among the most dwarf of the columbines offered. Similar to Cameo but even shorter, the series consists of numerous colors. Plants are excellent for protected areas, but not as good where other plants may overrun them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kurilensis’ (var. "), _c('em', [_vm._v("pumila")]), _vm._v(" ‘Kurilensis’) is only 4\" tall with blue, or blue and white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mini-Star’ is a dwarf 6-8\" tall cultivar with blue sepals and white petals. One of the best selections for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("nana")]), _vm._v(" is similar in habit and flower to the above cultivar. They appear to be different names for the same thing.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Spring Magic series is useful for the front of the garden bed and for containers. They are only a foot tall and are available in many colors.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("- x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("hybrida")])]), _vm._v(" (hy-brid' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18\"-3'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrids")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hybrids are particularly popular and with good reason. The flowers are large, upright, and in a wide range of colors. There are two generally accepted divisions in this group, long-spurred and short-spurred hybrids. Crosses involving "), _c('em', [_vm._v("A. canadensis")]), _vm._v(", "), _c('em', [_vm._v("A. chrysantha")]), _vm._v(", "), _c('em', [_vm._v("A. caerulea")]), _vm._v(", and "), _c('em', [_vm._v("A. formosa")]), _vm._v(" became known as the long-spurred hybrids and are most popular.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The recent upsurge in passion for hybrid columbines began with the McKana hybrids, an All-America bronze medal winner in 1955, which brought large flowers and pastel shades to the gardener. McKana hybrids superseded ‘Mrs. Scott Elliott’, another excellent strain. The breeding of hybrids continues at a furious pace and many excellent cultivars are available today.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Biedermeier’ is a 9-12\" compact blue and white cultivar, but other colors are also available in the mix. Often referred to as nosegay columbine. These contain a good deal of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" parentage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dragonfly’ consists of a mix of colors on 18-24\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fairyland Mix’ is a group of dwarf plants with short-spurred upright-facing flowers in various colors.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Firecracker’ is an exuberant 3' tall plant with dozens of flowers in explosive colors, mostly in rose and canary yellow with long yellow stamens. An outstanding plant in the Gardens at UGA in 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fairytale series is a series of 2' tall plants, available in various colors such as ‘Fairytale Violet’, ‘Fairytale Yellow’, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kristall’ (‘White Star’, ‘Kristal Star’) grows 2 1/2-3' tall with large white flowers and long straight spurs. A good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in the parentage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McKana hybrids are a series of columbines that have stayed the test of time. Large long-spurred flowers, which occur in many colors, are borne over 18-24\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Musik series is almost as good as the Song Birds. They are available in many colors although yellow is the best. They are free flowering and relatively compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Origami series consists of numerous colors (blue/white, rose/white, etc.) on 2 1/2' tall plants. These are the same as plants sold under the Butterfly series. ‘Origami Rose and White’ and ‘Origami Yellow’ earned the RHS Award of Garden Merit in 2003. These contain a good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in their parentage.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Song Bird series is the work of the late Charles Weddle, one of this country’s finest plant breeders. The plants are 2-3' tall and come in vibrant colors which are truly impressive. Some of those available include ‘Blue Bird’, light blue and white; ‘Blue Jay’, deep blue and white; ‘Cardinal’, rich violet and white; ‘Chaffinch’ (rose pink and white), ‘Dove’, nodding small blue and white flowers; ‘Nightingale’, lavender ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("and white; ‘Robin’, pale pink and white. ‘Chaffinch’ and ‘Dove’ were also Award of Garden Merit winners in 2003. The Songbird series is still popular but is being replaced by others such as the Spring Magic and Origami series.")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0113-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('p', {
    staticClass: "bibp"
  }, [_vm._v("‘Spring Song’ consists of 3' tall plants with spurs up to 3\" long. The flowers are available in mixed colors and some are nearly double.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Star series consists of 2-2 1/2' tall plants in various colors. ‘Blue Star’ and ‘Crimson Star’ (crimson sepals and white petals) are the most common. ‘Maxistar’ is yellow and at least 3' tall, and may be a cultivar of "), _c('em', [_vm._v("A. longissima")]), _vm._v(". All others have a good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in the parentage.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("State series is also sold as Swan series but at least in America, state names will sell more plants than swans any day. Some are listed as cultivars of "), _c('em', [_vm._v("A. flabellata")]), _vm._v(", others as "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(". Many state swans are out there, including (but not inclusive) ‘Alaska’ (‘Swan White’), ‘Colorado’ (‘Swan Violet and White’), ‘Florida’ (‘Swan Yellow’), ‘Georgia’ (‘Swan Red and White’), ‘Kansas’ (‘Swan Red and Yellow’), ")]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("‘Louisiana’ (‘Swan Burgundy and White’), ‘Montana’ (‘Swan Rose and White’) ‘Vermont’ and ‘Virginia’ (‘Swan Blue and White’). In a large columbine trial by the Royal Horticultural Society in 2003, ‘Alaska’, ‘Florida’ and ‘Georgia’ earned the Award of Garden Merit.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Windswept’ has short-spurred deep blue flowers on a 12-15\" tall plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Winky series consists of tall plants (2-3') in various colors. Red/white, purple/white and even ‘Tiddlywinks’ (mix) are part of this group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of the older long-spurred hybrids were crossed with "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" to yield the short-spurred hybrids. These are more popular in Europe than in the United States and are smaller in stature and bear smaller flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some hybrids are available from seed but self-sown seed will not necessarily resemble the parent. Leaf miner can be a serious pest and is more disruptive to the hybrids than to many of the species. If leaf miner damage makes you nauseous, the easiest control is to simply cut the plants down to the ground after flowering and destroy the leaves. New growth will soon appear at which time the life cycle of the miners will have been completed. An all-purpose insecticide may be applied in early spring as a preventative measure but is seldom effective once the damage is evident.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-longissima")])]), _vm._v(" (long-gis' si-ma)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Longspur Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The obvious attributes of this species are the very long (4\") slender spurs on pale yellow flowers. A grouping of 5-6 plants makes an impressive display. Unfortunately, though vigorous, it is a short-lived perennial seldom persisting for more than 2 years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Longissima Hybrids’ resulted from crosses among some of the long-spurred hybrids and "), _c('em', [_vm._v("A. longissima")]), _vm._v(" and contains different colors.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-vulgaris")])]), _vm._v(" (vul-gah' ris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Granny’s Bonnet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So much natural interbreeding among "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" and other species has occurred that it is becoming more and more difficult to find the true "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(". There is a great deal of variability but in general the flowers are blue or violet, with short incurved spurs which end in small knobs. It does not possess the classic statuesque form of "), _c('em', [_vm._v("A. alpina")]), _vm._v(", the sparkle of "), _c('em', [_vm._v("A. canadensis")]), _vm._v(", or the airiness of "), _c('em', [_vm._v("A. chrysantha")]), _vm._v(". However, it is a durable performer and has persisted well in gardens throughout the country, and has good heat tolerance, as shown by its performance in the State Botanical Garden of Georgia. Although I may be in the minority, I believe that some of the ugliest flowers in the plant kingdom are the doubles and near triple cultivars of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Adelaide Addison’ bears double purple and white flowers. For some reason, this is sometimes listed as ‘Nora’s Sister’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Altrosa’ produces rose-pink nodding flowers on 2-2 1/2' tall stems.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("alba")]), _vm._v(" is a good single white-flowered form.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Barlow series started out with ‘Nora Barlow’, a most interesting and unusual cultivar. Flowers are fully double and look more like small dahlias than columbines. The sepals are reddish pink with white margins and plants grow 2-2 1/2' tall. Nora was the granddaughter of Charles Darwin, and I can’t help but thinking of tortoises when I look at Nora. Association comes in strange forms. Nora has been around for decades but recent additions of ‘Blue Barlow’, ‘Rose Barlow’ and ‘Black Barlow now fill out the series.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cap de Rossiter’ has wonderful small pink and white dahlia-like flowers and even though I am not keen on double columbines, this one quickly became a favorite in the Armitage gardens. Plants grow 2-3' tall and flowers are persistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Clematiflora’, stormy columbine, bear lovely light pink to burgundy spurless flowers. The flat, nodding flowers are carried on 2' tall branching stems. These are often sold under the Clementine series, and may appear under names like ‘Clemantine Blue’, ‘Clementine Purple’ and ‘Clementine Red’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dorothy Rose’ has pendulous “hose in hose” dark pink flowers (looks like one flower is in another). Plants are about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Double Rubies’ (‘Burgundy Double’) produces deep maroon double flowers on 3' tall plants. Flowers are very persistent. I have seen a very similar plant listed as ‘Ruby Port’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Grandmother’s Garden’ is simply a mix of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" seedlings, each plant a different color, all plants 18-24\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Heidi’ bears handsome light pink nodding flowers on 18-24\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lime Frost’ is a yellow and green variegated form with few flowers. Similar plants may be found under ‘Variegata’ or ‘Woodside Gold’. ‘Lime Sorbet’ produces interesting, if you like them, double, spurless, off-white flowers. How many ways can we mess up this beautiful plant?")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mellow Yellow’ has golden yellow foliage with white or pale blue flowers in the spring. Plants are about 20\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Miss Jekyll’ produces nodding white flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nivea’ has single white flowers and pale gray foliage. It is vigorous, often attaining 3' in height. Plants may be seen as var. "), _c('em', [_vm._v("nivea")]), _vm._v(" and are also referred to as Munstead white columbine, in reference to Gertrude Jekyll’s fondness for the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Raspberry Tart’ is yet another gruesome deformed columbine offering, with raspberry red double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruby Port’ is a tall double-flowered form with ruby flowers. Great name, great plant, similar to ‘Double Rubies’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("stellata")]), _vm._v(" is the correct name for most of the spurless forms of columbine. Once classified as ‘Clematiflora’ or "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" var. "), _c('em', [_vm._v("clematiflora")]), _vm._v(", all stand about 2 1/2' tall and have double flowers with minute or no spurs. ‘Pink Spurless’, ‘Firewheel’, ‘Green Apples’ and ‘Iceberg’ are color variants in this variety. All are interesting, but none is beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Trevor Bath’, introduced by Canyon Creek Nursery in Oroville, California, carries rosy, short-spurred semi-double flowers with white petals and rose-red sepals.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("‘Variegata’ ("), _c('em', [_vm._v("A. vervaeneana")]), _vm._v(" ‘Variegata’) or ‘Woodside Variegated’ has foliage marbled with yellow or gold. The foliage is reasonably handsome in the spring but tends to fade as temperatures rise. Flowers are usually blue but may be white or purple.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Woodside Gold’ produces less marbled and more golden foliage than ‘Woodside Variegated’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘William Guinness’ (‘Magpie’), as would be expected, bears flowers the color of that fine stout. Double flowers are produced over the 2-3' tall plants in late spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hybrids are reasonably easy to find in today’s gardening market but there are dozens of lesser-known species that are fun to try. The only thing stopping gardeners is their availability. Here are few related species that, with a little hunting, may end up in your garden one of these days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. atrata")]), _vm._v(" is a handsome 18-30\" tall columbine with 1-2\" wide, nodding purple-violet flowers. This is similar to another dark-flowered form, "), _c('em', [_vm._v("A. nigrescens")]), _vm._v(". Hardy to about zone 4.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bertolonii")]), _vm._v(", alpine rock columbine, is only 4-9\" tall and bears rich blue-violet flowers. This is a wonderful dwarf columbine for the front of the border or rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. buergeriana")]), _vm._v(" produces nodding flowers of dull yellow petals and purple sepals on one- to two-foot tall plants. The straight short spurs are dull purple. ‘Calimero’ is a compact form with pendulous purple and cream yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. einseleana")]), _vm._v(" is another alpine species with nodding blue-violet flowers and short (1/2\") straight spurs. Plants are smaller than "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and usually grow 9-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. formosa")]), _vm._v(", formosa columbine, is native to the western United States and similar to "), _c('em', [_vm._v("A. canadensis")]), _vm._v(". Plants are taller and have sepals longer than the spurs. Even grown side by side, this species and "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" are difficult to separate. The var. "), _c('em', [_vm._v("truncata")]), _vm._v(" is sometimes offered as "), _c('em', [_vm._v("A. eximia")]), _vm._v(" and differs from the species in having much reduced petals. The formosa group does not perform as well as "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" in Eastern gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. glandulosa")]), _vm._v(", Siberian columbine, is almost identical to "), _c('em', [_vm._v("A. flabellata")]), _vm._v(", having fanlike bluish foliage and nodding blue flowers. If one looks closely, the pistils of this species are pubescent while the pistils are smooth in the fan columbine. The spur is strongly hooked in this species while it is curved in "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". Var. "), _c('em', [_vm._v("jucunda")]), _vm._v(" has white petals and is similar to "), _c('em', [_vm._v("A. flabellata")]), _vm._v(" ‘Alba’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("helenae")]), _vm._v(" (‘Helenae’) is a hybrid between "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" and "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". It has the blue and white flowers of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" and the short half-inch long spurs of "), _c('em', [_vm._v("A. flabellata")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Hensol Harebell’ was always believed to be a hybrid between "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and "), _c('em', [_vm._v("A. vulgaris;")]), _vm._v(" however, recent evidence suggests it may be a cultivar of "), _c('em', [_vm._v("A. alpina")]), _vm._v(". Plants bear deep blue flowers that continue well into summer. The branched flower stems produce an open, airy effect. Plants persisted about 2 years in the Armitage garden, and then various unrecognizable offspring took over.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('em', [_vm._v("A. laramiensis")]), _vm._v(" is also native to the Rocky Mountains and bears small white flowers that barely surpass the foliage. Plants grow 6-9\" tall and are best for well-drained rock garden sites")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. olympica")]), _vm._v(" is native to southern Europe and sports blue and white flowers with incurved spurs. Plants stand about 2 1/2' tall. Hardy in zones 4-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. oxysepala")]), _vm._v(" is closely related to "), _c('em', [_vm._v("A. buergeriana")]), _vm._v(", and grows 2-3' tall with interesting claret sepals and yellow petals. The spurs are strongly hooked. Native to Siberia, the plants have not enjoyed great success in the Armitage garden, but I have seen excellent plants in the Northeast and Midwest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pyrenaica")]), _vm._v(", native to the Pyrenees in northern Spain, bears nodding violet blue flowers with straight or slightly curved spurs. They are suitable for small areas or rock gardens due to their 8-12\" height.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. viridiflora")]), _vm._v(", green columbine, has nodding bicolored flowers with chocolate petals and yellow green sepals over blue-green foliage. Growing less than one foot tall, it is excellent for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arabis")])]), _vm._v(" (ar' a-bis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rock-cress")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47575d8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01a.vue
// module id = 75
// module chunks = 0